(function () {
    'use strict';

    var CONFIG = {
        design: 'd01',
        label: null,
        fallbackLabel: 'Pre-order',

        features: {
            preOrder: true,
            comingSoon: false,
            backInStock: false,
            lowStock: false
        },

        enhanceThemeButton: true,
        productPageOnly: true,
        respectReducedTransparency: true,

        picker: {
            enabled: true,
            urlParam: true,
            remember: true,
            startCollapsed: false,
            heading: 'Select a concept to preview'
        },

        glass: {
            blur: 14,
            saturate: 160,
            brightness: 1.03,
            tintAlpha: null,
            minTintAlpha: 0.26,
            maxTintAlpha: 0.55,
            minContrast: 4.5,
            refraction: 'auto',
            refractionScale: 34,
            lensBand: 18,
            lensPower: 1.6,
            lensBlur: 1,
            rim: true,
            dispersion: true,
            specular: true,
            tilt: 2.2,
            gel: true,
            driftSeconds: 14
        },

        glow: true,
        sheen: true,
        lift: true,
        intensity: 0.8,
        accentColor: null,
        neutralAccentColor: '#6b7280',
        sheenCycleSeconds: 12,
        hoverSheenSeconds: 0.9,
        breatheCycleSeconds: 3.2,
        pointerSpotlight: true,

        formSelector: 'form[action*="/cart/add"]',
        themeButtonSelector: [
            'button[type="submit"]',
            'input[type="submit"]',
            'button[name="add"]',
            '.product-form__submit',
            '.add-to-cart-button',
            '.product-form__add-button'
        ].join(','),
        skipSelector: '.shopify-payment-button__button, [data-shopify="payment-button"]'
    };

    var STATE_CLASS = 'ta-fx';
    var GLASS_CLASS = 'ta-glass';
    var LAYER_CLASS = 'ta-layer';
    var SHEEN_CLASS = 'ta-fx-sheen';
    var STYLE_ID = 'ta-fx-style';
    var SVG_ID = 'ta-glass-filters';
    var MARKERS = '[data-timesact-selling-plan],[data-timesact-property],[data-timesact-tracking],[name="properties[_timesact_preorder]"]';

    var PROXY_STYLE_ID = 'ta-pb-style';
    var PICKER_STYLE_ID = 'ta-pbp-style';
    var PICKER_ID = 'ta-pbp';
    var WARP_ID = 'ta-pb-liquid-warp';
    var SOURCE_CLASS = 'ta-pb-source';
    var OWN_SELECTOR = '.ta-pb-wrap,.ta-pbp,.ta-pbp-spacer,#' + WARP_ID + '-svg';
    var STORAGE_KEY = 'ta-pb-design';
    var BUTTON_SELECTOR = '.ta-pb,.ta-preorder-btn';
    var PACKAGE_CSS_KONSTNARSFABRIKEN = ".ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p01{min-height:52px;color:#121212;background:#fff;border:1px solid #121212;border-radius:0;font-family:var(--ta-font,Assistant,sans-serif);font-size:15px;font-weight:500;letter-spacing:1px;box-shadow:inset 0 0 0 3px #fff,inset 0 0 0 4px rgba(18,18,18,.16);transition:color .2s ease,background .2s ease,transform .14s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p01:hover:not(:disabled,[aria-disabled=\"true\"]){color:#fff;background:#121212}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p01 .ta-btn__arrow{transition:transform .2s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p01:hover:not(:disabled,[aria-disabled=\"true\"]) .ta-btn__arrow{transform:translateX(4px)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p01:active:not(:disabled,[aria-disabled=\"true\"]){transform:scale(.988)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p02{min-height:54px;color:#211d18;background:linear-gradient(105deg,#d8ceb9,#f3eee2 42%,#c8bda7 72%,#eee7d8);border:1px solid #8e836e;border-radius:2px;font-family:var(--ta-font,Assistant,sans-serif);font-size:15px;font-weight:650;letter-spacing:.8px;overflow:hidden;box-shadow:inset 0 1px rgba(255,255,255,.8),0 9px 20px rgba(78,68,52,.16);transition:transform .2s ease,box-shadow .2s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p02::before{content:\"\";position:absolute;top:-60%;bottom:-60%;left:-110px;width:70px;background:linear-gradient(90deg,transparent,rgba(255,255,255,.75),transparent);transform:skewX(-18deg);transition:left .58s ease;pointer-events:none}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p02:hover:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(-2px);box-shadow:0 14px 26px rgba(78,68,52,.22),inset 0 1px rgba(255,255,255,.9)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p02:hover:not(:disabled,[aria-disabled=\"true\"])::before{left:calc(100% + 40px)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p02:active:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(0) scale(.99)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p03{min-height:54px;padding:0 58px;color:#121212;background:#fff;border:1px solid #121212;border-radius:0;font-family:var(--ta-font,Assistant,sans-serif);font-size:15px;font-weight:600;letter-spacing:.9px;overflow:hidden;isolation:isolate;transition:color .26s ease,transform .15s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p03::before{content:\"\";position:absolute;right:9px;top:8px;width:36px;height:36px;border-radius:50%;background:#bf80c9;z-index:-1;transition:width .34s ease,height .34s ease,right .34s ease,top .34s ease,border-radius .34s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p03:hover:not(:disabled,[aria-disabled=\"true\"]){color:#171117}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p03:hover:not(:disabled,[aria-disabled=\"true\"])::before{right:-8%;top:-80%;width:116%;height:260%;border-radius:42%}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p03:active:not(:disabled,[aria-disabled=\"true\"]){transform:scale(.985)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p04{min-height:52px;color:#121212;background:#fff;border:1px solid #c7c7c7;border-radius:0;font-family:var(--ta-font,Assistant,sans-serif);font-size:15px;font-weight:500;letter-spacing:1px;overflow:hidden;transition:border-color .2s ease,transform .14s ease,box-shadow .2s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p04::before,.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p04::after{content:\"\";position:absolute;width:18px;height:18px;border-color:#121212;transition:width .24s ease,height .24s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p04::before{left:5px;top:5px;border-left:1px solid;border-top:1px solid}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p04::after{right:5px;bottom:5px;border-right:1px solid;border-bottom:1px solid}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p04:hover:not(:disabled,[aria-disabled=\"true\"]){border-color:#121212;box-shadow:0 8px 18px rgba(18,18,18,.08)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p04:hover:not(:disabled,[aria-disabled=\"true\"])::before,.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p04:hover:not(:disabled,[aria-disabled=\"true\"])::after{width:calc(100% - 10px);height:calc(100% - 10px)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p04:active:not(:disabled,[aria-disabled=\"true\"]){transform:scale(.988)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p05{min-height:52px;margin:0 0 5px;color:#201f1d;background:linear-gradient(180deg,#fffefb,#ece9e2);border:1px solid #aaa69d;border-radius:4px;font-family:var(--ta-font,Assistant,sans-serif);font-size:15px;font-weight:600;letter-spacing:.8px;box-shadow:0 5px 0 #aaa69d,0 10px 20px rgba(58,54,47,.13),inset 0 1px #fff;transform:translateY(-2px);transition:transform .1s ease,box-shadow .1s ease,filter .18s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p05:hover:not(:disabled,[aria-disabled=\"true\"]){filter:brightness(1.02);transform:translateY(-4px);box-shadow:0 7px 0 #aaa69d,0 14px 24px rgba(58,54,47,.17),inset 0 1px #fff}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p05:active:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(3px);box-shadow:0 1px 0 #aaa69d,0 5px 10px rgba(58,54,47,.12)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p06{min-height:54px;color:#241627;background:linear-gradient(120deg,rgba(255,255,255,.78),rgba(255,255,255,.25)),linear-gradient(125deg,#efd8f3,#bf80c9 58%,#a966b5);border:1px solid rgba(92,47,102,.38);border-radius:999px;font-family:var(--ta-font,Assistant,sans-serif);font-size:15px;font-weight:650;letter-spacing:.8px;box-shadow:inset 0 1px #fff,inset 0 -8px 14px rgba(103,50,114,.12),0 10px 24px rgba(103,50,114,.18);overflow:hidden;transition:transform .2s ease,filter .2s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p06::before{content:\"\";position:absolute;inset:-80% -25%;background:conic-gradient(from 90deg,transparent,rgba(255,255,255,.88),transparent 24%);transform:translateX(-55%) rotate(8deg);transition:transform .58s ease;pointer-events:none}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p06 .ta-btn__label,.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p06 .ta-btn__arrow{position:relative}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p06:hover:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(-2px);filter:saturate(1.12)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p06:hover:not(:disabled,[aria-disabled=\"true\"])::before{transform:translateX(55%) rotate(8deg)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p06:active:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(0) scale(.99)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p07{min-height:56px;color:#171717;background-color:#efe8d8;background-image:radial-gradient(circle at 10% 25%,#d77a42 0 3px,transparent 4px),radial-gradient(circle at 25% 72%,#bf80c9 0 4px,transparent 5px),radial-gradient(circle at 44% 26%,#667d68 0 3px,transparent 4px),radial-gradient(circle at 67% 70%,#d7b74e 0 4px,transparent 5px),radial-gradient(circle at 86% 30%,#557f9d 0 3px,transparent 4px);background-size:118px 56px;border:2px solid #171717;border-radius:0;font-family:var(--ta-font,Assistant,sans-serif);font-size:15px;font-weight:700;letter-spacing:.9px;box-shadow:7px 7px 0 #171717;margin:0 7px 7px 0;transition:transform .12s ease,box-shadow .12s ease,background-position .3s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p07 .ta-btn__label,.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p07 .ta-btn__arrow{background:#fff;padding:6px 8px;box-shadow:0 0 0 1px rgba(23,23,23,.18)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p07:hover:not(:disabled,[aria-disabled=\"true\"]){transform:translate(-2px,-2px);box-shadow:10px 10px 0 #171717;background-position:18px 0}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p07:active:not(:disabled,[aria-disabled=\"true\"]){transform:translate(5px,5px);box-shadow:1px 1px 0 #171717}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p08{min-height:52px;color:#121212;background:#fff;border:1px solid #121212;border-radius:0;font-family:var(--ta-font,Assistant,sans-serif);font-size:15px;font-weight:500;letter-spacing:1px;overflow:hidden;isolation:isolate;transition:color .24s ease,transform .15s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p08::before{content:\"\";position:absolute;left:0;right:0;bottom:0;height:100%;background:#121212;transform:translateY(102%);z-index:-1;transition:transform .28s cubic-bezier(.2,.8,.2,1);pointer-events:none}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p08:hover:not(:disabled,[aria-disabled=\"true\"]){color:#fff}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p08:hover:not(:disabled,[aria-disabled=\"true\"])::before{transform:translateY(0)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p08:active:not(:disabled,[aria-disabled=\"true\"]){transform:scale(.988)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p09{min-height:54px;padding:0 56px;color:#fff;background:#151515;border:1px solid #151515;border-radius:0;font-family:var(--ta-font,Assistant,sans-serif);font-size:15px;font-weight:650;letter-spacing:1px;box-shadow:inset 5px 0 #ce7028;transition:transform .18s ease,box-shadow .22s ease,background .2s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p09 .ta-btn__arrow{position:absolute;right:20px;color:#e88b43;transition:transform .22s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p09:hover:not(:disabled,[aria-disabled=\"true\"]){background:#242424;transform:translateY(-2px);box-shadow:inset 8px 0 #ce7028,0 12px 24px rgba(0,0,0,.2)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p09:hover:not(:disabled,[aria-disabled=\"true\"]) .ta-btn__arrow{transform:translateX(4px)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p09:active:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(0) scale(.99)}@property --ta-p10-angle{syntax:\"<angle>\";inherits:false;initial-value:0deg}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p10{min-height:56px;color:#fff;border:2px solid transparent;border-radius:999px;background-image:linear-gradient(#171717,#171717),conic-gradient(from var(--ta-p10-angle),#bf80c9,#e88b43,#d7b74e,#67a587,#6e91c4,#bf80c9);background-origin:padding-box,border-box;background-clip:padding-box,border-box;font-family:var(--ta-font,Assistant,sans-serif);font-size:15px;font-weight:650;letter-spacing:.9px;animation:ta-p10-swirl 7s linear infinite;box-shadow:0 11px 26px rgba(38,25,41,.24);transition:transform .2s ease,box-shadow .2s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p10 .ta-btn__arrow{color:#e8b4ef;transition:transform .22s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p10:hover:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(-2px);box-shadow:0 16px 34px rgba(60,30,67,.25),0 0 20px rgba(191,128,201,.18)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p10:hover:not(:disabled,[aria-disabled=\"true\"]) .ta-btn__arrow{transform:translate(3px,-3px)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p10:active:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(0) scale(.99)}@keyframes ta-p10-swirl{to{--ta-p10-angle:360deg}}";
    var PACKAGE_CSS_KIDNOVA = ".ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p01{min-height:52px;color:#3e3d3d;background:#fdcd64;border-radius:8px;font-family:var(--ta-font,Poppins,sans-serif);font-size:17px;font-weight:700;letter-spacing:1px;text-transform:uppercase;box-shadow:0 4px 0 #e3a93b;transition:transform .15s ease,box-shadow .15s ease,background-color .2s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p01:hover:not(:disabled,[aria-disabled=\"true\"]){background:#fed67c;transform:translateY(-1px);box-shadow:0 5px 0 #e3a93b}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p01 .ta-btn__arrow{transition:transform .2s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p01:hover:not(:disabled,[aria-disabled=\"true\"]) .ta-btn__arrow{transform:translateX(4px)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p01:active:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(4px);box-shadow:0 0 0 #e3a93b}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p02{min-height:52px;color:#3e3d3d;background:#fff;border:2px solid #3e3d3d;border-radius:8px;font-family:var(--ta-font,Poppins,sans-serif);font-size:16px;font-weight:700;letter-spacing:1px;text-transform:uppercase;overflow:hidden;isolation:isolate;transition:transform .15s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p02::before{content:\"\";position:absolute;inset:0;z-index:-1;background:#fdcd64;transform:scaleY(.14);transform-origin:bottom;transition:transform .32s cubic-bezier(.2,.8,.2,1);pointer-events:none}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p02:hover:not(:disabled,[aria-disabled=\"true\"])::before{transform:scaleY(1)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p02 .ta-btn__arrow{transition:transform .2s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p02:hover:not(:disabled,[aria-disabled=\"true\"]) .ta-btn__arrow{transform:translateX(4px)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p02:active:not(:disabled,[aria-disabled=\"true\"]){transform:scale(.985)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p03{min-height:52px;color:#3e3d3d;background:#fdcd64;border-radius:8px;font-family:var(--ta-font,Poppins,sans-serif);font-size:17px;font-weight:700;letter-spacing:1px;text-transform:uppercase;overflow:hidden;isolation:isolate;box-shadow:inset 0 -3px 0 rgba(62,61,61,.12);transition:transform .2s ease,box-shadow .2s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p03::before{content:\"\";position:absolute;z-index:-1;top:50%;left:-70px;width:56px;height:56px;margin-top:-28px;border-radius:50%;background:radial-gradient(circle,rgba(255,255,255,.95) 0,rgba(255,255,255,.45) 38%,rgba(255,255,255,0) 70%);transition:left .7s cubic-bezier(.3,.7,.3,1);pointer-events:none}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p03:hover:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(-2px);box-shadow:inset 0 -3px 0 rgba(62,61,61,.12),0 10px 20px rgba(227,169,59,.35)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p03:hover:not(:disabled,[aria-disabled=\"true\"])::before{left:calc(100% + 14px)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p03 .ta-btn__arrow{transition:transform .2s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p03:hover:not(:disabled,[aria-disabled=\"true\"]) .ta-btn__arrow{transform:translateX(4px)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p03:active:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(0) scale(.985)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p04{width:calc(100% - 6px);min-height:52px;color:#3e3d3d;background:#fdcd64;border:2px solid #3e3d3d;border-radius:8px;font-family:var(--ta-font,Poppins,sans-serif);font-size:17px;font-weight:700;letter-spacing:1px;text-transform:uppercase;box-shadow:4px 4px 0 #3e3d3d;transform:rotate(-1deg);transition:transform .15s ease,box-shadow .15s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p04:hover:not(:disabled,[aria-disabled=\"true\"]){transform:rotate(0deg) translate(-2px,-2px);box-shadow:6px 6px 0 #3e3d3d}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p04 .ta-btn__arrow{transition:transform .2s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p04:hover:not(:disabled,[aria-disabled=\"true\"]) .ta-btn__arrow{transform:translateX(4px)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p04:active:not(:disabled,[aria-disabled=\"true\"]){transform:rotate(0deg) translate(3px,3px);box-shadow:1px 1px 0 #3e3d3d}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p05{min-height:52px;color:#fff;background:linear-gradient(54deg,#6d388b 14%,#690e0e 85%);background-size:180% 100%;background-position:0 0;border-radius:8px;font-family:var(--ta-font,Poppins,sans-serif);font-size:17px;font-weight:700;letter-spacing:1px;text-transform:uppercase;box-shadow:0 6px 16px rgba(109,56,139,.28);transition:background-position .45s ease,transform .2s ease,box-shadow .2s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p05 .ta-btn__arrow{color:#fdcd64;transition:transform .2s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p05:hover:not(:disabled,[aria-disabled=\"true\"]){background-position:100% 0;transform:translateY(-1px);box-shadow:0 10px 22px rgba(109,56,139,.36)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p05:hover:not(:disabled,[aria-disabled=\"true\"]) .ta-btn__arrow{transform:translateX(4px)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p05:active:not(:disabled,[aria-disabled=\"true\"]){transform:scale(.985)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p06{min-height:52px;color:#3e3d3d;background:#fdcd64;border-radius:8px;font-family:var(--ta-font,Poppins,sans-serif);font-size:17px;font-weight:700;letter-spacing:2.6px;text-transform:uppercase;transition:letter-spacing .35s ease,transform .15s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p06::after{content:\"\";position:absolute;inset:-6px;border:2px dashed rgba(109,56,139,.35);border-radius:13px;transition:inset .35s cubic-bezier(.2,.8,.2,1),border-color .35s ease,border-radius .35s ease;pointer-events:none}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p06:hover:not(:disabled,[aria-disabled=\"true\"]){letter-spacing:1px}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p06:hover:not(:disabled,[aria-disabled=\"true\"])::after{inset:-3px;border-style:solid;border-color:#6d388b;border-radius:10px}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p06 .ta-btn__arrow{transition:transform .2s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p06:hover:not(:disabled,[aria-disabled=\"true\"]) .ta-btn__arrow{transform:translate(2px,-2px)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p06:active:not(:disabled,[aria-disabled=\"true\"]){transform:scale(.985)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p07{min-height:52px;color:#3e3d3d;background:#fdcd64;border-radius:8px;font-family:var(--ta-font,Poppins,sans-serif);font-size:17px;font-weight:700;letter-spacing:1px;text-transform:uppercase;overflow:hidden;transition:transform .15s ease,box-shadow .2s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p07::after{content:\"\";position:absolute;bottom:7px;left:14px;width:9px;height:7px;border-radius:50% 50% 45% 45%;background:#2e8b3c;box-shadow:0 0 0 2px rgba(46,139,60,.18);animation:ta-p07-crawl 7s ease-in-out infinite;pointer-events:none}@keyframes ta-p07-crawl{0%,8%{left:14px}46%,54%{left:calc(100% - 23px)}92%,100%{left:14px}}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p07:hover:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(-1px);box-shadow:0 8px 18px rgba(227,169,59,.35)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p07 .ta-btn__arrow{transition:transform .2s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p07:hover:not(:disabled,[aria-disabled=\"true\"]) .ta-btn__arrow{transform:translateX(4px)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p07:active:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(0) scale(.985)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p08{min-height:52px;color:#3e3d3d;background:#fdcd64;border-radius:999px;font-family:var(--ta-font,Poppins,sans-serif);font-size:16px;font-weight:700;letter-spacing:.4px;text-transform:none;box-shadow:0 8px 20px rgba(253,205,100,.5);transition:transform .2s ease,box-shadow .2s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p08 .ta-btn__arrow{display:inline-flex;align-items:center;justify-content:center;width:26px;height:26px;border-radius:50%;background:#3e3d3d;color:#fdcd64;font-size:14px;transition:transform .2s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p08:hover:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(-2px);box-shadow:0 12px 26px rgba(253,205,100,.6)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p08:hover:not(:disabled,[aria-disabled=\"true\"]) .ta-btn__arrow{transform:translateX(3px)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p08:active:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(0) scale(.985)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p09{min-height:52px;color:#3e3d3d;background:#fdcd64;border-radius:8px;font-family:var(--ta-font,Poppins,sans-serif);font-size:17px;font-weight:700;letter-spacing:1px;text-transform:uppercase;overflow:hidden;isolation:isolate;transition:transform .2s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p09::before{content:\"\";position:absolute;z-index:-1;left:50%;top:50%;width:640px;height:640px;margin:-320px 0 0 -320px;background:repeating-conic-gradient(from 0deg,rgba(255,255,255,.34) 0deg 9deg,rgba(255,255,255,0) 9deg 18deg);opacity:.4;animation:ta-p09-spin 14s linear infinite;transition:opacity .3s ease;pointer-events:none}@keyframes ta-p09-spin{to{transform:rotate(360deg)}}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p09:hover:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(-1px)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p09:hover:not(:disabled,[aria-disabled=\"true\"])::before{opacity:1}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p09 .ta-btn__arrow{transition:transform .2s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p09:hover:not(:disabled,[aria-disabled=\"true\"]) .ta-btn__arrow{transform:translateX(4px)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p09:active:not(:disabled,[aria-disabled=\"true\"]){transform:scale(.985)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p10{min-height:52px;color:#3e3d3d;background:linear-gradient(180deg,#fff,#f4f4f4);border:2px solid #3e3d3d;border-radius:8px;font-family:var(--ta-font,Poppins,sans-serif);font-size:16px;font-weight:700;letter-spacing:1px;text-transform:uppercase;overflow:hidden;isolation:isolate;transition:transform .15s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p10::before{content:\"\";position:absolute;z-index:-1;top:7px;bottom:7px;left:50%;width:150px;transform:translateX(-50%);background:#fdcd64;border-radius:4px;transition:width .4s cubic-bezier(.2,.8,.2,1),top .4s cubic-bezier(.2,.8,.2,1),bottom .4s cubic-bezier(.2,.8,.2,1),border-radius .4s ease;pointer-events:none}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p10::after{content:\"\";position:absolute;inset:4px;border:1px solid rgba(62,61,61,.14);border-radius:5px;pointer-events:none}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p10:hover:not(:disabled,[aria-disabled=\"true\"])::before{width:100%;top:0;bottom:0;border-radius:0}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p10 .ta-btn__arrow{transition:transform .2s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p10:hover:not(:disabled,[aria-disabled=\"true\"]) .ta-btn__arrow{transform:translateX(4px)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--p10:active:not(:disabled,[aria-disabled=\"true\"]){transform:scale(.985)}";
    var PACKAGE_CSS = ".ta-preorder-cta{display:block;width:100%;margin:0;padding:0;box-sizing:border-box}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn{all:unset;box-sizing:border-box;position:relative;display:flex;align-items:center;justify-content:center;gap:9.6px;width:100%;min-height:52px;margin:0;padding:0 24px;border:0;border-radius:0;background:none;color:#111;font:750 15px/1 var(--ta-font,system-ui,-apple-system,\"Segoe UI\",Roboto,Helvetica,Arial,sans-serif);letter-spacing:-.01em;text-transform:none;text-align:center;text-decoration:none;white-space:nowrap;box-shadow:none;transform:none;filter:none;opacity:1;cursor:pointer;-webkit-appearance:none;appearance:none;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}.ta-preorder-cta .ta-preorder-btn .ta-btn__label,.ta-preorder-cta .ta-preorder-btn .ta-btn__arrow{display:inline-block;margin:0;padding:0;border:0;background:none;color:inherit;font:inherit;line-height:1;letter-spacing:inherit;text-transform:inherit;text-decoration:none;box-shadow:none;}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn:focus-visible{outline:2px solid #2563eb;outline-offset:3px;}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn:disabled,.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn[aria-disabled=\"true\"]{cursor:not-allowed;opacity:.5;transform:none;filter:saturate(.6);}@media (prefers-reduced-motion:reduce){.ta-preorder-cta .ta-preorder-btn,.ta-preorder-cta .ta-preorder-btn *,.ta-preorder-cta .ta-preorder-btn::before,.ta-preorder-cta .ta-preorder-btn::after{transition-duration:.001ms !important;animation:none !important;}}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v01{color:#fff;border-radius:14px;background:linear-gradient(180deg,#8b5cf6,#6d28d9);box-shadow:0 9px 20px rgba(109,40,217,.30),inset 0 1px rgba(255,255,255,.22);overflow:hidden;transition:transform .18s ease,box-shadow .18s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v01::before{content:\"\";position:absolute;top:-40%;bottom:-40%;left:-110px;width:72px;transform:skewX(-20deg);background:linear-gradient(90deg,transparent,rgba(255,255,255,.55),transparent);transition:left .52s ease;pointer-events:none}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v01:hover:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(-2px);box-shadow:0 14px 28px rgba(109,40,217,.36),inset 0 1px rgba(255,255,255,.30)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v01:hover:not(:disabled,[aria-disabled=\"true\"])::before{left:calc(100% + 40px)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v01:active:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(1px)}@property --ta-v02-angle{syntax:\"<angle>\";inherits:false;initial-value:210deg}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v02{color:#fff;border-radius:999px;background:#111827;isolation:isolate;box-shadow:0 12px 28px rgba(17,24,39,.26);transition:transform .22s ease,box-shadow .22s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v02::before{content:\"\";position:absolute;inset:-2px;border-radius:inherit;z-index:-2;background:conic-gradient(from var(--ta-v02-angle),#22d3ee,#8b5cf6,#ec4899,#f59e0b,#22d3ee);filter:blur(8px);opacity:.78;animation:ta-v02-spin 6s linear infinite;transition:opacity .25s ease,filter .25s ease;pointer-events:none}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v02::after{content:\"\";position:absolute;inset:2px;border-radius:inherit;background:#111827;z-index:-1;pointer-events:none}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v02:hover:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(-2px) scale(1.02);box-shadow:0 18px 36px rgba(17,24,39,.30)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v02:hover:not(:disabled,[aria-disabled=\"true\"])::before{opacity:1;filter:blur(11px)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v02:active:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(1px) scale(.99)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v02:disabled::before,.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v02[aria-disabled=\"true\"]::before{animation:none}@keyframes ta-v02-spin{to{--ta-v02-angle:570deg}}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v03{margin:3px 0 9px;color:#fff;border-radius:14px;background:linear-gradient(#fb7185,#e11d48);box-shadow:0 7px 0 #9f1239,0 14px 24px rgba(159,18,57,.25),inset 0 1px rgba(255,255,255,.3);transform:translateY(-3px);transition:transform .09s ease,box-shadow .09s ease,filter .15s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v03:hover:not(:disabled,[aria-disabled=\"true\"]){filter:brightness(1.04);transform:translateY(-5px);box-shadow:0 9px 0 #9f1239,0 17px 28px rgba(159,18,57,.26),inset 0 1px rgba(255,255,255,.3)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v03:active:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(4px);box-shadow:0 1px 0 #9f1239,0 6px 12px rgba(159,18,57,.22),inset 0 1px rgba(255,255,255,.25)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v04{padding:0 58px;color:#111827;border-radius:999px;background:#fff;border:1px solid #d7dce3;box-shadow:0 8px 20px rgba(17,24,39,.08);overflow:hidden;transition:transform .22s ease,box-shadow .22s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v04 .ta-btn__label{position:relative;z-index:1;transition:color .2s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v04 .ta-btn__arrow{position:absolute;top:6px;right:7px;box-sizing:border-box;display:flex;align-items:center;justify-content:flex-end;width:38px;height:38px;padding:0 10px 0 0;border-radius:999px;color:#fff;background:#111827;font-size:19px;font-weight:400;transition:width .28s cubic-bezier(.2,.7,.2,1)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v04:hover:not(:disabled,[aria-disabled=\"true\"]) .ta-btn__arrow{width:calc(100% - 14px)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v04:hover:not(:disabled,[aria-disabled=\"true\"]) .ta-btn__label{color:#fff}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v04:active:not(:disabled,[aria-disabled=\"true\"]){transform:scale(.985)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v05{color:#111827;border-radius:13px;background:#fff;border:2px solid #111827;overflow:hidden;isolation:isolate;transition:color .24s ease,transform .16s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v05::before,.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v05::after{content:\"\";position:absolute;top:0;width:52%;height:100%;background:#111827;z-index:-1;transition:transform .30s cubic-bezier(.2,.8,.2,1);pointer-events:none}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v05::before{left:0;transform:translateX(-105%)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v05::after{right:0;transform:translateX(105%)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v05:hover:not(:disabled,[aria-disabled=\"true\"]){color:#fff}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v05:hover:not(:disabled,[aria-disabled=\"true\"])::before,.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v05:hover:not(:disabled,[aria-disabled=\"true\"])::after{transform:translateX(0)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v05:active:not(:disabled,[aria-disabled=\"true\"]){transform:scale(.985)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v06{width:calc(100% - 9px);margin:0 9px 9px 0;color:#111;border-radius:9px;background:#fde047;border:2px solid #111;box-shadow:6px 6px 0 #111;transition:transform .11s ease,box-shadow .11s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v06:hover:not(:disabled,[aria-disabled=\"true\"]){transform:translate(-2px,-2px);box-shadow:9px 9px 0 #111}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v06:active:not(:disabled,[aria-disabled=\"true\"]){transform:translate(5px,5px);box-shadow:1px 1px 0 #111}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v07{color:#17111f;border-radius:999px;background:linear-gradient(110deg,rgba(255,255,255,.76),rgba(255,255,255,.28)),linear-gradient(120deg,#a7f3d0,#c4b5fd 38%,#fbcfe8 66%,#fde68a);border:1px solid rgba(255,255,255,.95);box-shadow:inset 0 1px 0 #fff,inset 0 -7px 13px rgba(139,92,246,.10),0 10px 25px rgba(88,28,135,.15);overflow:hidden;transition:transform .22s ease,filter .22s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v07::before{content:\"\";position:absolute;inset:-80% -30%;background:conic-gradient(from 90deg,transparent,rgba(255,255,255,.9),transparent 22%);transform:translateX(-50%) rotate(10deg);transition:transform .6s cubic-bezier(.2,.8,.2,1);pointer-events:none}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v07 .ta-btn__label,.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v07 .ta-btn__arrow{position:relative}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v07:hover:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(-2px) scale(1.02);filter:saturate(1.15)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v07:hover:not(:disabled,[aria-disabled=\"true\"])::before{transform:translateX(55%) rotate(10deg)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v07:active:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(0) scale(.99)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v08{color:#fff;border-radius:16px;border:2px solid transparent;background-image:linear-gradient(#111318,#111318),linear-gradient(90deg,#0ea5e9,#8b5cf6,#ec4899,#0ea5e9);background-origin:padding-box,border-box;background-clip:padding-box,border-box;background-size:100% 100%,300% 100%;background-repeat:no-repeat,repeat;background-position:0 0,0 0;animation:ta-v08-flow 4s linear infinite;transition:transform .18s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v08:hover:not(:disabled,[aria-disabled=\"true\"]){background-image:linear-gradient(#171a21,#171a21),linear-gradient(90deg,#0ea5e9,#8b5cf6,#ec4899,#0ea5e9)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v08:active:not(:disabled,[aria-disabled=\"true\"]){transform:scale(.985)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v08:disabled,.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v08[aria-disabled=\"true\"]{animation:none}@keyframes ta-v08-flow{to{background-position:0 0,300% 0}}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v09{color:#fff8e8;border-radius:999px;background:linear-gradient(180deg,#3b1838,#1e0e20);border:1px solid rgba(245,214,146,.62);box-shadow:inset 0 1px 0 rgba(255,255,255,.12),inset 0 -1px 0 rgba(245,214,146,.14),0 11px 26px rgba(30,14,32,.28);transition:transform .2s ease,box-shadow .2s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v09::before{content:\"\";position:absolute;inset:4px;border-radius:inherit;border:1px solid rgba(245,214,146,.20);pointer-events:none}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v09:hover:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(-2px);box-shadow:inset 0 1px 0 rgba(255,255,255,.14),0 15px 34px rgba(30,14,32,.36),0 0 0 3px rgba(245,214,146,.08)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v09:active:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(0) scale(.988)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v10{color:#fff;border-radius:999px;background:#2563eb;box-shadow:0 10px 24px rgba(37,99,235,.28);transition:transform .18s ease,background .18s ease}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v10::before{content:\"\";position:absolute;inset:-1px;border-radius:inherit;border:2px solid rgba(37,99,235,.75);box-shadow:0 0 14px rgba(37,99,235,.4);animation:ta-pulse-v10 2.2s ease-out infinite;pointer-events:none}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v10:hover:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(-2px);background:#1d4ed8}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v10:active:not(:disabled,[aria-disabled=\"true\"]){transform:translateY(0) scale(.985)}.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v10:disabled::before,.ta-preorder-cta .ta-preorder-btn.ta-preorder-btn--v10[aria-disabled=\"true\"]::before{animation:none;opacity:0}@keyframes ta-pulse-v10{0%{opacity:.95;inset:-1px}72%,100%{opacity:0;inset:-10px -22px}}";
    var LABEL_SKIP = 'svg,template,script,style,[hidden],[aria-hidden="true"],.visually-hidden,.sr-only,.hidden,[class*="added"],[class*="loading"],[class*="loader"],[class*="spinner"],[class*="icon"]';

    function supportsBackdrop() {
        return typeof CSS !== 'undefined' && !!CSS.supports &&
            (CSS.supports('backdrop-filter', 'blur(4px)') || CSS.supports('-webkit-backdrop-filter', 'blur(4px)'));
    }

    function prefersReducedTransparency() {
        return CONFIG.respectReducedTransparency &&
            window.matchMedia('(prefers-reduced-transparency: reduce)').matches;
    }

    function supportsRefraction() {
        var setting = CONFIG.glass.refraction;
        if (setting === false) return false;
        if (!supportsBackdrop()) return false;
        if (!CSS.supports('backdrop-filter', 'url(#x)')) return false;
        if (setting === true) return true;
        return /Chrome|Chromium|Edg\//.test(navigator.userAgent) && !/OPR\//.test(navigator.userAgent);
    }

    function activeStyle(engine) {
        if (engine !== 'glass') return 'glow';
        if (!supportsBackdrop() || prefersReducedTransparency()) return 'glow';
        return 'glass';
    }

    var css = [
        '.' + STATE_CLASS + '{',
        'position:relative;',
        'isolation:isolate;',
        'overflow:hidden;',
        'transition:transform .28s cubic-bezier(.2,.7,.3,1),box-shadow .28s cubic-bezier(.2,.7,.3,1),filter .28s ease;',
        'animation:ta-fx-breathe var(--ta-fx-breathe,3.6s) ease-in-out infinite;',
        '}',

        '.' + STATE_CLASS + '::before{',
        'content:"";',
        'position:absolute;',
        'inset:0;',
        'border-radius:inherit;',
        'pointer-events:none;',
        'background:var(--ta-fx-idlewash,transparent);',
        'box-shadow:inset 0 0 0 1px var(--ta-fx-edge,rgba(255,255,255,.22)),inset 0 1px 0 var(--ta-fx-inner,rgba(255,255,255,.18));',
        'transition:background .3s ease,box-shadow .3s ease;',
        'z-index:1;',
        '}',

        '.' + STATE_CLASS + ' > *:not(.' + SHEEN_CLASS + '){position:relative;z-index:2;}',

        '.' + STATE_CLASS + ' > .' + SHEEN_CLASS + ',.' + SHEEN_CLASS + '{',
        'position:absolute;',
        'inset:0;',
        'border-radius:inherit;',
        'overflow:hidden;',
        'pointer-events:none;',
        'z-index:1;',
        '}',

        '.' + STATE_CLASS + '.ta-fx-intro > .' + SHEEN_CLASS + '::after{animation-duration:3s;}',

        '.' + SHEEN_CLASS + '::after{',
        'content:"";',
        'position:absolute;',
        'top:-60%;',
        'bottom:-60%;',
        'left:-40%;',
        'width:42%;',
        'transform:skewX(-18deg) translateX(-140%);',
        'background:linear-gradient(100deg,transparent,var(--ta-fx-sheen,rgba(255,255,255,.55)) 45%,var(--ta-fx-sheen,rgba(255,255,255,.55)) 55%,transparent);',
        'filter:blur(.4px);',
        'animation:ta-fx-sweep var(--ta-fx-sweep,12s) cubic-bezier(.3,.6,.3,1) infinite;',
        '}',

        '.' + STATE_CLASS + '.ta-fx-lift{cursor:pointer;}',

        '.' + STATE_CLASS + '.ta-fx-lift:hover{',
        'transform:translateY(-2px) scale(1.012);',
        'filter:brightness(1.07) saturate(1.06);',
        'box-shadow:0 0 0 4px var(--ta-fx-ring,rgba(0,0,0,.16)),0 18px 38px -12px var(--ta-fx-glow,rgba(0,0,0,.45)),0 2px 6px -2px var(--ta-fx-glow,rgba(0,0,0,.3));',
        'animation-play-state:paused;',
        '}',

        '.' + STATE_CLASS + '.ta-fx-lift:hover > .' + SHEEN_CLASS + '::before{',
        'content:"";',
        'position:absolute;',
        'top:-60%;',
        'bottom:-60%;',
        'left:-40%;',
        'width:46%;',
        'background:linear-gradient(100deg,transparent,var(--ta-fx-sheen-strong,rgba(255,255,255,.75)),transparent);',
        'animation:ta-fx-sweep-hover var(--ta-fx-hover,.9s) cubic-bezier(.22,.65,.28,1) 1;',
        '}',

        '.' + STATE_CLASS + '.ta-fx-lift:hover::before{',
        'background:radial-gradient(180px circle at var(--ta-mx,50%) var(--ta-my,50%),var(--ta-fx-spot,rgba(255,255,255,.22)),transparent 62%),var(--ta-fx-wash,transparent);',
        'box-shadow:inset 0 0 0 1px var(--ta-fx-edge-strong,rgba(255,255,255,.4)),inset 0 1px 0 var(--ta-fx-inner,rgba(255,255,255,.22));',
        '}',

        '.' + STATE_CLASS + '.ta-fx-lift:active{',
        'transform:translateY(0) scale(.994);',
        'filter:none;',
        'box-shadow:0 0 0 2px var(--ta-fx-ring,rgba(0,0,0,.14)),0 6px 14px -8px var(--ta-fx-glow,rgba(0,0,0,.4));',
        '}',

        '.' + STATE_CLASS + ':focus-visible{',
        'outline:2px solid var(--ta-fx-glow,rgba(0,0,0,.45));',
        'outline-offset:3px;',
        '}',

        '@keyframes ta-fx-breathe{',
        '0%,100%{box-shadow:0 0 0 1px var(--ta-fx-ring,rgba(0,0,0,.10)),0 8px 20px -10px var(--ta-fx-glow,rgba(0,0,0,.35));}',
        '50%{box-shadow:0 0 0 7px var(--ta-fx-ring-soft,rgba(0,0,0,.05)),0 18px 34px -12px var(--ta-fx-glow,rgba(0,0,0,.5));}',
        '}',

        '@keyframes ta-fx-sweep{',
        '0%{transform:skewX(-18deg) translateX(-140%);opacity:0;}',
        '4%{opacity:1;}',
        '42%{opacity:1;}',
        '50%{transform:skewX(-18deg) translateX(560%);opacity:0;}',
        '100%{transform:skewX(-18deg) translateX(560%);opacity:0;}',
        '}',

        '@keyframes ta-fx-sweep-hover{',
        '0%{transform:skewX(-18deg) translateX(-160%);opacity:0;}',
        '12%{opacity:1;}',
        '88%{opacity:1;}',
        '100%{transform:skewX(-18deg) translateX(560%);opacity:0;}',
        '}',

        '.' + GLASS_CLASS + '{',
        'position:relative;',
        'isolation:isolate;',
        'border-color:transparent;',
        'background:var(--ta-glass-tint,rgba(255,255,255,.16));',
        '-webkit-backdrop-filter:var(--ta-glass-backdrop,blur(14px) saturate(180%) brightness(1.06));',
        'backdrop-filter:var(--ta-glass-backdrop,blur(14px) saturate(180%) brightness(1.06));',
        'box-shadow:',
        'inset 0 1px 1px var(--ta-glass-bevel,rgba(255,255,255,.62)),',
        'inset 0 -1px 1px var(--ta-glass-bounce,rgba(255,255,255,.22)),',
        'inset 0 0 var(--ta-glass-coresize,16px) var(--ta-glass-core,rgba(255,255,255,.10)),',
        '0 1px 1px var(--ta-glass-contact,rgba(0,0,0,.08)),',
        '0 12px 28px -12px var(--ta-glass-drop,rgba(0,0,0,.45));',
        'transform:perspective(700px) rotateX(var(--ta-glass-rx,0deg)) rotateY(var(--ta-glass-ry,0deg)) translateY(var(--ta-glass-y,0px)) scale(var(--ta-glass-s,1));',
        'transition:box-shadow .35s cubic-bezier(.2,.7,.3,1),transform .35s cubic-bezier(.34,1.28,.64,1),background .35s ease;',
        '}',

        '.' + GLASS_CLASS + ' > *:not(.' + LAYER_CLASS + '){position:relative;z-index:5;}',

        '.' + GLASS_CLASS + ' > .' + LAYER_CLASS + '{',
        'position:absolute;',
        'inset:0;',
        'border-radius:inherit;',
        'pointer-events:none;',
        '}',

        '.ta-layer-lens{',
        'z-index:1;',
        '-webkit-backdrop-filter:var(--ta-glass-lens,blur(7px) brightness(1.08) saturate(150%));',
        'backdrop-filter:var(--ta-glass-lens,blur(7px) brightness(1.08) saturate(150%));',
        '-webkit-mask:radial-gradient(130% 130% at 50% 50%,transparent 52%,#000 94%);',
        'mask:radial-gradient(130% 130% at 50% 50%,transparent 52%,#000 94%);',
        '}',

        '.ta-layer-disp{',
        'z-index:2;',
        'padding:2.4px;',
        'filter:blur(1.2px);',
        'opacity:var(--ta-glass-dispersion,.5);',
        'background:conic-gradient(from calc(var(--ta-glass-angle,200deg) + 18deg),rgba(120,220,255,.6),transparent 22%,transparent 60%,rgba(255,140,220,.55) 86%,rgba(120,220,255,.6));',
        '-webkit-mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);',
        '-webkit-mask-composite:xor;',
        'mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);',
        'mask-composite:exclude;',
        '}',

        '.ta-layer-rim{',
        'z-index:3;',
        'padding:var(--ta-glass-rimwidth,1.2px);',
        'background:conic-gradient(from var(--ta-glass-angle,200deg),',
        'var(--ta-glass-spec,rgba(255,255,255,.98)),',
        'rgba(255,255,255,.18) 14%,rgba(255,255,255,0) 30%,',
        'var(--ta-glass-spec-soft,rgba(255,255,255,.42)) 50%,rgba(255,255,255,0) 66%,',
        'var(--ta-glass-spec,rgba(255,255,255,.98)) 88%,var(--ta-glass-spec,rgba(255,255,255,.98)));',
        '-webkit-mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);',
        '-webkit-mask-composite:xor;',
        'mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);',
        'mask-composite:exclude;',
        'transition:padding .3s ease;',
        '}',

        '.ta-layer-scrim{',
        'z-index:4;',
        'background:radial-gradient(64% 130% at 50% 50%,var(--ta-glass-scrim,transparent),transparent 76%);',
        '}',

        '.ta-layer-spec{',
        'z-index:4;',
        'background:radial-gradient(70% 140% at var(--ta-mx,50%) var(--ta-my,0%),var(--ta-glass-sheen,rgba(255,255,255,.34)),transparent 62%);',
        'opacity:0;',
        'transition:opacity .35s ease;',
        '}',

        '.' + GLASS_CLASS + '.ta-glass-live{cursor:pointer;}',

        '.' + GLASS_CLASS + '.ta-glass-live:hover{',
        '--ta-glass-y:-1.5px;',
        'box-shadow:',
        'inset 0 1px 1px var(--ta-glass-bevel-strong,rgba(255,255,255,.8)),',
        'inset 0 -1px 1px var(--ta-glass-bounce,rgba(255,255,255,.3)),',
        'inset 0 0 calc(var(--ta-glass-coresize,16px) * 1.5) var(--ta-glass-core-strong,rgba(255,255,255,.18)),',
        '0 1px 1px var(--ta-glass-contact,rgba(0,0,0,.08)),',
        '0 20px 40px -14px var(--ta-glass-drop-strong,rgba(0,0,0,.55));',
        '}',

        '.' + GLASS_CLASS + '.ta-glass-live:hover > .ta-layer-spec{opacity:1;}',
        '.' + GLASS_CLASS + '.ta-glass-live:hover > .ta-layer-rim{padding:calc(var(--ta-glass-rimwidth,1.2px) + .5px);}',

        '.' + GLASS_CLASS + '.ta-glass-live:active{',
        '--ta-glass-s:.982;',
        '--ta-glass-y:0px;',
        '--ta-glass-rx:0deg;',
        '--ta-glass-ry:0deg;',
        'transition:transform .1s ease-out,box-shadow .1s ease-out;',
        '}',

        '.' + GLASS_CLASS + ':focus-visible{outline:2px solid var(--ta-glass-focus,rgba(255,255,255,.85));outline-offset:3px;}',

        '@media (prefers-reduced-motion:reduce){',
        '.' + STATE_CLASS + '{animation:none;box-shadow:0 0 0 3px var(--ta-fx-ring,rgba(0,0,0,.1)),0 10px 22px -12px var(--ta-fx-glow,rgba(0,0,0,.35));}',
        '.' + SHEEN_CLASS + '::after{animation:none;opacity:0;}',
        '.' + STATE_CLASS + '.ta-fx-lift:hover > .' + SHEEN_CLASS + '::before{animation:none;opacity:0;}',
        '.' + STATE_CLASS + '.ta-fx-lift:hover{transform:none;}',
        '.' + GLASS_CLASS + '{transition:none;}',
        '.' + GLASS_CLASS + '.ta-glass-live:hover{--ta-glass-y:0px;}',
        '}'
    ].join('');

    function injectStyle() {
        if (document.getElementById(STYLE_ID)) return;
        var style = document.createElement('style');
        style.id = STYLE_ID;
        style.textContent = css;
        (document.head || document.documentElement).appendChild(style);
    }

    function parseColor(value) {
        if (!value) return null;
        var match = value.match(/rgba?\(([^)]+)\)/);
        if (!match) return null;
        var parts = match[1].split(/[,\s/]+/).filter(Boolean).map(parseFloat);
        if (parts.length < 3 || parts.slice(0, 3).some(isNaN)) return null;
        return { r: parts[0], g: parts[1], b: parts[2], a: parts.length > 3 && !isNaN(parts[3]) ? parts[3] : 1 };
    }

    function pickAccent(element) {
        var styles = getComputedStyle(element);
        var candidates = [styles.backgroundColor, styles.borderTopColor, styles.color];
        for (var i = 0; i < candidates.length; i++) {
            var color = parseColor(candidates[i]);
            if (color && color.a > 0.05) return color;
        }
        return { r: 30, g: 30, b: 30, a: 1 };
    }

    function pickSurface(element) {
        var node = element.parentElement;
        while (node && node !== document.documentElement) {
            var color = parseColor(getComputedStyle(node).backgroundColor);
            if (color && color.a > 0.35) return color;
            node = node.parentElement;
        }
        return { r: 255, g: 255, b: 255, a: 1 };
    }

    function luminance(color) {
        return (0.2126 * color.r + 0.7152 * color.g + 0.0722 * color.b) / 255;
    }

    function relativeLuminance(color) {
        var channel = function (value) {
            var v = value / 255;
            return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
        };
        return 0.2126 * channel(color.r) + 0.7152 * channel(color.g) + 0.0722 * channel(color.b);
    }

    function contrastRatio(a, b) {
        var la = relativeLuminance(a) + 0.05;
        var lb = relativeLuminance(b) + 0.05;
        return la > lb ? la / lb : lb / la;
    }

    function composite(top, alpha, bottom) {
        return {
            r: top.r * alpha + bottom.r * (1 - alpha),
            g: top.g * alpha + bottom.g * (1 - alpha),
            b: top.b * alpha + bottom.b * (1 - alpha),
            a: 1
        };
    }

    function saturation(color) {
        var max = Math.max(color.r, color.g, color.b);
        var min = Math.min(color.r, color.g, color.b);
        return max === 0 ? 0 : (max - min) / max;
    }

    function hexToColor(hex) {
        if (!hex) return null;
        var value = hex.replace('#', '');
        if (value.length === 3) value = value.split('').map(function (c) { return c + c; }).join('');
        if (value.length !== 6) return null;
        return {
            r: parseInt(value.slice(0, 2), 16),
            g: parseInt(value.slice(2, 4), 16),
            b: parseInt(value.slice(4, 6), 16),
            a: 1
        };
    }

    function rgba(color, alpha) {
        return 'rgba(' + Math.round(color.r) + ',' + Math.round(color.g) + ',' + Math.round(color.b) + ',' + alpha.toFixed(3) + ')';
    }

    var filters = { node: null, cache: {} };

    function filterRoot() {
        if (filters.node && document.body.contains(filters.node)) return filters.node;
        var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('id', SVG_ID);
        svg.setAttribute('width', '0');
        svg.setAttribute('height', '0');
        svg.setAttribute('aria-hidden', 'true');
        svg.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden;pointer-events:none';
        document.body.appendChild(svg);
        filters.node = svg;
        return svg;
    }

    function displacementMap(width, height, radius) {
        var glass = CONFIG.glass;
        var scale = Math.min(1, 200 / Math.max(width, height));
        var mw = Math.max(8, Math.round(width * scale));
        var mh = Math.max(8, Math.round(height * scale));

        var canvas = document.createElement('canvas');
        canvas.width = mw;
        canvas.height = mh;
        var context = canvas.getContext('2d');
        var image = context.createImageData(mw, mh);

        var cx = width / 2;
        var cy = height / 2;
        var r = Math.min(radius, cx, cy);
        var band = Math.max(4, Math.min(glass.lensBand, Math.min(width, height) * 0.28));

        for (var y = 0; y < mh; y++) {
            for (var x = 0; x < mw; x++) {
                var i = (y * mw + x) * 4;
                var px = (x + 0.5) / mw * width;
                var py = (y + 0.5) / mh * height;

                var qx = Math.abs(px - cx) - (cx - r);
                var qy = Math.abs(py - cy) - (cy - r);
                var ax = Math.max(qx, 0);
                var ay = Math.max(qy, 0);
                var distance = Math.hypot(ax, ay) + Math.min(Math.max(qx, qy), 0) - r;

                var nx, ny;
                if (qx > 0 && qy > 0) {
                    var length = Math.hypot(ax, ay) || 1;
                    nx = ax / length;
                    ny = ay / length;
                } else if (qx > qy) {
                    nx = 1;
                    ny = 0;
                } else {
                    nx = 0;
                    ny = 1;
                }
                nx *= Math.sign(px - cx) || 1;
                ny *= Math.sign(py - cy) || 1;

                var t = 1 + distance / band;
                t = t < 0 ? 0 : (t > 1 ? 1 : t);
                var amount = Math.pow(t, glass.lensPower);

                image.data[i] = Math.max(0, Math.min(255, Math.round(128 + nx * amount * 127)));
                image.data[i + 1] = Math.max(0, Math.min(255, Math.round(128 + ny * amount * 127)));
                image.data[i + 2] = 128;
                image.data[i + 3] = 255;
            }
        }

        context.putImageData(image, 0, 0);
        return canvas.toDataURL();
    }

    function refractionFilter(width, height, radius) {
        var key = width + 'x' + height + 'r' + radius;
        if (filters.cache[key]) return filters.cache[key];

        var id = 'ta-glass-' + key.replace(/[^a-z0-9]/gi, '');
        var filter = document.createElementNS('http://www.w3.org/2000/svg', 'filter');
        filter.setAttribute('id', id);
        filter.setAttribute('x', '0');
        filter.setAttribute('y', '0');
        filter.setAttribute('width', '100%');
        filter.setAttribute('height', '100%');
        filter.setAttribute('filterUnits', 'objectBoundingBox');
        filter.setAttribute('color-interpolation-filters', 'sRGB');
        filter.innerHTML =
            '<feImage href="' + displacementMap(width, height, radius) + '" preserveAspectRatio="none" result="map"/>' +
            '<feDisplacementMap in="SourceGraphic" in2="map" scale="' +
            Math.max(6, Math.min(CONFIG.glass.refractionScale, Math.min(width, height) * 0.34)).toFixed(1) + '" ' +
            'xChannelSelector="R" yChannelSelector="G"/>';

        filterRoot().appendChild(filter);
        filters.cache[key] = id;
        return id;
    }

    function cornerRadius(element) {
        var value = parseFloat(getComputedStyle(element).borderTopLeftRadius);
        return isNaN(value) ? 0 : value;
    }

    function applyGlassTokens(element) {
        var glass = CONFIG.glass;
        var styles = getComputedStyle(element);
        var surface = pickSurface(element);
        var text = parseColor(styles.color) || { r: 255, g: 255, b: 255, a: 1 };
        var base = parseColor(styles.backgroundColor);

        if (!base || base.a < 0.08) base = pickAccent(element);
        if (luminance(base) > 0.9 && luminance(surface) > 0.7) {
            var fallback = hexToColor(CONFIG.neutralAccentColor);
            if (fallback) base = fallback;
        }

        var alpha = glass.tintAlpha;
        if (alpha === null) {
            alpha = glass.minTintAlpha;
            while (alpha < glass.maxTintAlpha &&
                contrastRatio(text, composite(base, alpha, surface)) < glass.minContrast) {
                alpha = Math.min(glass.maxTintAlpha, alpha + 0.03);
            }
        }

        var behind = composite(base, alpha, surface);
        var dark = luminance(behind) < 0.5;

        var scrim = null;
        if (contrastRatio(text, behind) < glass.minContrast) {
            var shade = luminance(text) > 0.5 ? { r: 0, g: 0, b: 0, a: 1 } : { r: 255, g: 255, b: 255, a: 1 };
            var veil = 0.1;
            while (veil < 0.62 && contrastRatio(text, composite(shade, veil, behind)) < glass.minContrast) {
                veil += 0.04;
            }
            scrim = rgba(shade, veil);
        }
        element.style.setProperty('--ta-glass-scrim', scrim || 'transparent');

        element.style.setProperty('--ta-glass-tint', rgba(base, alpha));
        element.style.setProperty('--ta-glass-backdrop',
            'blur(' + glass.blur + 'px) saturate(' + glass.saturate + '%) brightness(' +
            (dark ? glass.brightness : 1) + ')');
        element.style.setProperty('--ta-glass-lens',
            'blur(' + Math.max(glass.lensBlur, 5) + 'px) saturate(140%) brightness(1.03)');

        var height = element.getBoundingClientRect().height || 48;
        element.style.setProperty('--ta-glass-coresize', Math.round(Math.min(16, height * 0.2)) + 'px');
        var etch = { r: base.r * 0.55, g: base.g * 0.55, b: base.b * 0.55, a: 1 };

        element.style.setProperty('--ta-glass-bevel', 'rgba(255,255,255,' + (dark ? 0.62 : 0.5) + ')');
        element.style.setProperty('--ta-glass-bevel-strong', 'rgba(255,255,255,' + (dark ? 0.82 : 0.65) + ')');
        element.style.setProperty('--ta-glass-bounce', 'rgba(255,255,255,' + (dark ? 0.22 : 0.18) + ')');
        element.style.setProperty('--ta-glass-core', dark ? 'rgba(255,255,255,.1)' : 'rgba(255,255,255,0)');
        element.style.setProperty('--ta-glass-core-strong', dark ? 'rgba(255,255,255,.18)' : 'rgba(255,255,255,.05)');
        element.style.setProperty('--ta-glass-contact', rgba(base, 0.1));
        var shadowTone = composite(base, 0.4, { r: 0, g: 0, b: 0, a: 1 });
        element.style.setProperty('--ta-glass-drop', rgba(shadowTone, dark ? 0.5 : 0.38));
        element.style.setProperty('--ta-glass-drop-strong', rgba(shadowTone, dark ? 0.62 : 0.5));
        element.style.setProperty('--ta-glass-spec', dark ? 'rgba(255,255,255,.98)' : rgba(etch, 0.62));
        element.style.setProperty('--ta-glass-spec-soft', dark ? 'rgba(255,255,255,.42)' : rgba(etch, 0.16));
        element.style.setProperty('--ta-glass-sheen', dark ? 'rgba(255,255,255,.34)' : rgba(etch, 0.14));
        element.style.setProperty('--ta-glass-focus', rgba(base, 0.85));
        element.style.setProperty('--ta-glass-dispersion', glass.dispersion ? '.5' : '0');
    }

    function applyRefraction(element) {
        if (!supportsRefraction()) return;
        var lens = element.querySelector('.ta-layer-lens');
        if (!lens) return;

        var box = element.getBoundingClientRect();
        var width = Math.round(box.width);
        var height = Math.round(box.height);
        if (!width || !height) return;

        var radius = Math.round(cornerRadius(element));
        var signature = width + 'x' + height + 'r' + radius;
        if (lens._taSignature === signature) return;
        lens._taSignature = signature;

        var value = 'url(#' + refractionFilter(width, height, radius) + ') ' +
            'blur(' + CONFIG.glass.lensBlur + 'px) saturate(140%) brightness(1.02)';
        lens.style.setProperty('-webkit-backdrop-filter', value);
        lens.style.setProperty('backdrop-filter', value);
        lens.style.setProperty('-webkit-mask', 'none');
        lens.style.setProperty('mask', 'none');
    }

    function applyTokens(element) {
        var accent = pickAccent(element);
        var surface = pickSurface(element);
        var lightSurface = luminance(surface) > 0.62;
        var strength = Math.max(0, Math.min(1, CONFIG.intensity));

        var forced = hexToColor(CONFIG.accentColor);
        if (forced) accent = forced;

        if (luminance(accent) > 0.72) accent = { r: accent.r * 0.55, g: accent.g * 0.55, b: accent.b * 0.55, a: 1 };

        if (!forced && saturation(accent) < 0.12) {
            var fallback = hexToColor(CONFIG.neutralAccentColor);
            if (fallback) accent = fallback;
        }

        var glowAlpha = lightSurface ? (0.30 * strength + 0.16) : (0.46 * strength + 0.24);
        var ringAlpha = lightSurface ? (0.16 * strength + 0.06) : (0.24 * strength + 0.08);

        element.style.setProperty('--ta-fx-glow', rgba(accent, glowAlpha));
        element.style.setProperty('--ta-fx-ring', rgba(accent, ringAlpha));
        element.style.setProperty('--ta-fx-ring-soft', rgba(accent, ringAlpha * 0.45));
        element.style.setProperty('--ta-fx-sheen', lightSurface
            ? rgba(accent, 0.10 + 0.12 * strength)
            : 'rgba(255,255,255,' + (0.42 + 0.3 * strength).toFixed(2) + ')');
        element.style.setProperty('--ta-fx-sheen-strong', lightSurface
            ? rgba(accent, 0.18 + 0.14 * strength)
            : 'rgba(255,255,255,' + Math.min(0.9, 0.6 + 0.3 * strength).toFixed(2) + ')');
        element.style.setProperty('--ta-fx-inner', lightSurface ? 'rgba(0,0,0,.05)' : 'rgba(255,255,255,.2)');
        element.style.setProperty('--ta-fx-edge', lightSurface ? rgba(accent, 0.20) : 'rgba(255,255,255,.2)');
        element.style.setProperty('--ta-fx-edge-strong', lightSurface ? rgba(accent, 0.38) : 'rgba(255,255,255,.42)');
        element.style.setProperty('--ta-fx-idlewash', lightSurface ? rgba(accent, 0.07) : 'rgba(255,255,255,.04)');
        element.style.setProperty('--ta-fx-wash', lightSurface ? rgba(accent, 0.16) : 'rgba(255,255,255,.1)');
        element.style.setProperty('--ta-fx-spot', lightSurface ? rgba(accent, 0.26) : 'rgba(255,255,255,.24)');
        element.style.setProperty('--ta-fx-breathe', CONFIG.breatheCycleSeconds + 's');
        element.style.setProperty('--ta-fx-sweep', CONFIG.sheenCycleSeconds + 's');
        element.style.setProperty('--ta-fx-hover', CONFIG.hoverSheenSeconds + 's');
    }

    function canHoldChildren(element) {
        return element.tagName !== 'INPUT';
    }

    function addLayer(element, name) {
        if (element.querySelector('.ta-layer-' + name)) return;
        var layer = document.createElement('span');
        layer.className = LAYER_CLASS + ' ta-layer-' + name;
        layer.setAttribute('aria-hidden', 'true');
        element.appendChild(layer);
    }

    function trackPointer(element, glassMode) {
        if (element._taPointer) return;
        var frame = null;
        var tilt = CONFIG.glass.tilt;

        element._taPointer = function (event) {
            if (frame) return;
            frame = requestAnimationFrame(function () {
                frame = null;
                var box = element.getBoundingClientRect();
                if (!box.width || !box.height) return;

                if (!glassMode) {
                    element.style.setProperty('--ta-mx', Math.round(event.clientX - box.left) + 'px');
                    element.style.setProperty('--ta-my', Math.round(event.clientY - box.top) + 'px');
                    return;
                }

                var x = (event.clientX - box.left) / box.width;
                var y = (event.clientY - box.top) / box.height;

                element.style.setProperty('--ta-mx', (x * 100).toFixed(1) + '%');
                element.style.setProperty('--ta-my', (y * 100).toFixed(1) + '%');
                element.style.setProperty('--ta-glass-angle',
                    (Math.atan2(y - 0.5, x - 0.5) * 180 / Math.PI + 180).toFixed(0) + 'deg');

                if (tilt > 0) {
                    element.style.setProperty('--ta-glass-ry', ((x - 0.5) * 2 * tilt).toFixed(2) + 'deg');
                    element.style.setProperty('--ta-glass-rx', ((0.5 - y) * 2 * tilt).toFixed(2) + 'deg');
                }
            });
        };

        element._taLeave = function () {
            element.style.removeProperty('--ta-glass-rx');
            element.style.removeProperty('--ta-glass-ry');
        };

        element.addEventListener('pointermove', element._taPointer);
        element.addEventListener('pointerleave', element._taLeave);
    }

    function enhanceGlass(element, feature) {
        element.setAttribute('data-ta-fx', feature);
        element.classList.add(GLASS_CLASS);
        if (CONFIG.glass.gel) element.classList.add('ta-glass-live');

        applyGlassTokens(element);

        if (canHoldChildren(element)) {
            addLayer(element, 'lens');
            if (CONFIG.glass.dispersion) addLayer(element, 'disp');
            if (CONFIG.glass.rim) addLayer(element, 'rim');
            addLayer(element, 'scrim');
            if (CONFIG.glass.specular) addLayer(element, 'spec');
            applyRefraction(element);

            if (!element._taResize && typeof ResizeObserver !== 'undefined') {
                element._taResize = new ResizeObserver(function () { applyRefraction(element); });
                element._taResize.observe(element);
            }
        }

        trackPointer(element, true);
    }

    function enhanceGlow(element, feature) {
        element.setAttribute('data-ta-fx', feature);
        element.classList.add(STATE_CLASS);
        if (CONFIG.lift) element.classList.add('ta-fx-lift');
        if (!CONFIG.glow) element.style.setProperty('animation', 'none');

        applyTokens(element);

        if (CONFIG.sheen && canHoldChildren(element) && !element.querySelector('.' + SHEEN_CLASS)) {
            var sheen = document.createElement('span');
            sheen.className = SHEEN_CLASS;
            sheen.setAttribute('aria-hidden', 'true');
            element.appendChild(sheen);

            element.classList.add('ta-fx-intro');
            setTimeout(function () { element.classList.remove('ta-fx-intro'); }, 3200);
        }

        if (CONFIG.pointerSpotlight) trackPointer(element, false);
    }

    function enhance(element, feature, engine) {
        if (!element || element.matches(CONFIG.skipSelector)) return;
        if (element.getAttribute('data-ta-fx') === feature && element.getAttribute('data-ta-engine') === engine) {
            if (element.classList.contains(GLASS_CLASS)) applyRefraction(element);
            return;
        }
        if (element.hasAttribute('data-ta-fx')) reset(element);

        element.setAttribute('data-ta-engine', engine);
        if (activeStyle(engine) === 'glass') {
            enhanceGlass(element, feature);
        } else {
            enhanceGlow(element, feature);
        }
    }

    function reset(element) {
        element.removeAttribute('data-ta-fx');
        element.removeAttribute('data-ta-engine');
        element.classList.remove(STATE_CLASS, 'ta-fx-lift', 'ta-fx-intro', GLASS_CLASS, 'ta-glass-live');
        element.style.removeProperty('animation');

        if (element._taPointer) {
            element.removeEventListener('pointermove', element._taPointer);
            element._taPointer = null;
        }
        if (element._taLeave) {
            element.removeEventListener('pointerleave', element._taLeave);
            element._taLeave = null;
        }
        if (element._taResize) {
            element._taResize.disconnect();
            element._taResize = null;
        }

        ['--ta-fx-glow', '--ta-fx-ring', '--ta-fx-ring-soft', '--ta-fx-sheen', '--ta-fx-sheen-strong', '--ta-fx-inner',
            '--ta-fx-edge', '--ta-fx-edge-strong', '--ta-fx-idlewash', '--ta-fx-wash', '--ta-fx-spot',
            '--ta-mx', '--ta-my', '--ta-fx-breathe', '--ta-fx-sweep', '--ta-fx-hover',
            '--ta-glass-tint', '--ta-glass-backdrop', '--ta-glass-lens', '--ta-glass-bevel', '--ta-glass-bevel-strong',
            '--ta-glass-bounce', '--ta-glass-core', '--ta-glass-core-strong', '--ta-glass-contact', '--ta-glass-drop',
            '--ta-glass-drop-strong', '--ta-glass-spec', '--ta-glass-spec-soft', '--ta-glass-sheen', '--ta-glass-focus',
            '--ta-glass-dispersion', '--ta-glass-scrim', '--ta-glass-coresize', '--ta-glass-angle', '--ta-glass-rx', '--ta-glass-ry',
            '--ta-glass-y', '--ta-glass-s'].forEach(function (token) {
            element.style.removeProperty(token);
        });

        var sheen = element.querySelector('.' + SHEEN_CLASS);
        if (sheen) sheen.remove();
        element.querySelectorAll('.' + LAYER_CLASS).forEach(function (layer) { layer.remove(); });
    }

    function activeFeatures() {
        return Object.keys(CONFIG.features).filter(function (feature) { return CONFIG.features[feature]; });
    }

    var GROUPS = [
        { id: 'defaults', label: 'Defaults', css: [] },
        { id: 'konstnarsfabriken', label: "Konstnärsfabriken", css: [] },
        { id: 'kidnova', label: "Kidnova", css: [] }
    ];

    var ICONS = {
        crown: '<svg viewBox="0 0 576 512" aria-hidden="true" focusable="false"><path d="M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z"/></svg>'
    };

    var ARROW = '→';
    var ARROW_UP = '↗';

    var DESIGNS = [
        { key: 'd01', group: 'defaults', n: 1, name: 'Shine Sweep', pkg: 'v01', arrow: ARROW, tags: ['restrained'], desc: 'Solid CTA with one reflective streak on hover.' },
        { key: 'd02', group: 'defaults', n: 2, name: 'Aurora Glow', pkg: 'v02', arrow: ARROW_UP, tags: ['strong', 'always animated'], desc: 'Dark pill with a slowly rotating multicolour halo that brightens on hover.' },
        { key: 'd03', group: 'defaults', n: 3, name: 'Tactile 3D', pkg: 'v03', arrow: ARROW, tags: ['strong'], desc: 'Physical ledge and a real press state.' },
        { key: 'd04', group: 'defaults', n: 4, name: 'Arrow Reveal', pkg: 'v04', arrow: ARROW, tags: ['restrained'], desc: 'Outline pill whose arrow disc expands into a dark fill on hover.' },
        { key: 'd05', group: 'defaults', n: 5, name: 'Split Slide Fill', pkg: 'v05', arrow: ARROW, tags: ['restrained'], desc: 'Outlined button that fills from both sides on hover.' },
        { key: 'd06', group: 'defaults', n: 6, name: 'Neo-Brutalist Lift', pkg: 'v06', arrow: ARROW_UP, tags: ['experimental'], desc: 'Hard offset shadow and bold yellow.' },
        { key: 'd07', group: 'defaults', n: 7, name: 'Iridescent Pearl', pkg: 'v07', arrow: ARROW, tags: ['strong'], desc: 'Pastel pearl finish with a light sweep on hover.' },
        { key: 'd08', group: 'defaults', n: 8, name: 'Border Beam', pkg: 'v08', arrow: ARROW, tags: ['strong', 'always animated'], desc: 'Dark button whose gradient border flows continuously.' },
        { key: 'd09', group: 'defaults', n: 9, name: 'Velvet Luxury', pkg: 'v09', arrow: ARROW, tags: ['restrained'], desc: 'Deep plum with a fine gold double frame.' },
        { key: 'd10', group: 'defaults', n: 10, name: 'Pulse Halo', pkg: 'v10', arrow: ARROW, tags: ['experimental', 'always animated'], desc: 'Blue pill with a glowing ring that pulses outward.' },
        { key: 'k01', group: 'konstnarsfabriken', n: 1, name: "Studio Outline", pkg: 'p01', arrow: ARROW, tags: ['restrained'], desc: "A faithful refinement of the current square white CTA, with a crisp charcoal edge and a quiet inner line." },
        { key: 'k02', group: 'konstnarsfabriken', n: 2, name: "Mineral Pour", pkg: 'p02', arrow: ARROW, tags: ['strong'], desc: "Warm mineral tones and a fluid highlight reference Jesmonite as it moves from liquid mix to a smooth cast surface." },
        { key: 'k03', group: 'konstnarsfabriken', n: 3, name: "Pigment Drop", pkg: 'p03', arrow: ARROW, tags: ['strong'], desc: "A focused violet pigment drop spreads across a clean studio-white button on hover, echoing colour mixed into Jesmonite." },
        { key: 'k04', group: 'konstnarsfabriken', n: 4, name: "Casting Frame", pkg: 'p04', arrow: ARROW, tags: ['restrained'], desc: "Precise corner marks turn the current outline into a subtle mould-like frame while preserving the store’s minimal character." },
        { key: 'k05', group: 'konstnarsfabriken', n: 5, name: "Soft Plaster", pkg: 'p05', arrow: ARROW, tags: ['restrained'], desc: "An ivory cast finish and shallow sculptural ledge bring gentle material depth without departing far from the white storefront." },
        { key: 'k06', group: 'konstnarsfabriken', n: 6, name: "Resin Tint", pkg: 'p06', arrow: ARROW_UP, tags: ['strong'], desc: "A translucent lilac surface picks up the store’s customer-club purple and gives it a polished material treatment." },
        { key: 'k07', group: 'konstnarsfabriken', n: 7, name: "Terrazzo Mix", pkg: 'p07', arrow: ARROW, tags: ['experimental'], desc: "A lively terrazzo field turns the product’s castable, pigment-friendly character into a distinctive creative-studio CTA." },
        { key: 'k08', group: 'konstnarsfabriken', n: 8, name: "Mould Release", pkg: 'p08', arrow: ARROW, tags: ['restrained'], desc: "A restrained charcoal fill releases upward from the baseline, adding clear interaction to the store’s flat rectangular control." },
        { key: 'k09', group: 'konstnarsfabriken', n: 9, name: "Studio Signal", pkg: 'p09', arrow: ARROW, tags: ['strong'], desc: "A decisive charcoal CTA with the review-star orange as a narrow signal edge adds salience while staying store-native." },
        { key: 'k10', group: 'konstnarsfabriken', n: 10, name: "Liquid Swirl", pkg: 'p10', arrow: ARROW_UP, tags: ['experimental'], desc: "A slow multicolour perimeter reflects the playful circular logo and the product’s pigment-mixing potential around a sober dark centre." },
        { key: 'n01', group: 'kidnova', n: 1, name: "Sunny Classic", pkg: 'p01', arrow: ARROW, tags: ['restrained'], desc: "A polished take on your current yellow button, with a small 3D ledge that presses down like a real toy button." },
        { key: 'n02', group: 'kidnova', n: 2, name: "Yellow Fill", pkg: 'p02', arrow: ARROW, tags: ['restrained'], desc: "A clean outlined button where your signature yellow fills up from the bottom." },
        { key: 'n03', group: 'kidnova', n: 3, name: "Lens Glint", pkg: 'p03', arrow: ARROW, tags: ['restrained'], desc: "A soft light passes across the button like a magnifying glass catching the sun, a nod to the Kidnova lens." },
        { key: 'n04', group: 'kidnova', n: 4, name: "Sticker Tag", pkg: 'p04', arrow: ARROW, tags: ['bold'], desc: "A tilted sticker style borrowed from your “Legnépszerűbb” tag, playful and easy to spot." },
        { key: 'n05', group: 'kidnova', n: 5, name: "Discovery Purple", pkg: 'p05', arrow: ARROW, tags: ['bold'], desc: "Your purple accent gradient turns the button into a bold statement, with a yellow arrow to keep it Kidnova." },
        { key: 'n06', group: 'kidnova', n: 6, name: "Focus Ring", pkg: 'p06', arrow: ARROW_UP, tags: ['experimental'], desc: "Spaced-out lettering pulls into focus inside a purple ring, like adjusting a microscope." },
        { key: 'n07', group: 'kidnova', n: 7, name: "Beetle Trail", pkg: 'p07', arrow: ARROW, tags: ['bold'], desc: "A tiny green beetle wanders along the button, just like the one under the lens in your product photo." },
        { key: 'n08', group: 'kidnova', n: 8, name: "Soft Pill", pkg: 'p08', arrow: ARROW, tags: ['restrained'], desc: "A friendly rounded pill with a dark arrow badge, soft and approachable for parents." },
        { key: 'n09', group: 'kidnova', n: 9, name: "Sunburst", pkg: 'p09', arrow: ARROW, tags: ['bold'], desc: "Slowly turning sun rays add warmth and energy while keeping your yellow." },
        { key: 'n10', group: 'kidnova', n: 10, name: "Specimen Slide", pkg: 'p10', arrow: ARROW, tags: ['experimental'], desc: "Styled like a microscope slide: the yellow sample in the middle grows to fill the button on hover." },
        {
            key: 'original', group: 'defaults', n: 0, name: 'Theme button', mode: 'none', hidden: true,
            tags: ['no change'],
            desc: 'The store’s own button exactly as the theme and Timesact render it.'
        }
    ];

    DESIGNS.forEach(function (design) {
        if (!design.mode) design.mode = 'proxy';
    });

    var STORE_BUTTON = window.TA_BUTTON || null;
    if (STORE_BUTTON) {
        if (STORE_BUTTON.pkg) {
            DESIGNS.push({
                key: 'store', group: 'defaults', n: 0, name: STORE_BUTTON.name || 'Store button', pkg: STORE_BUTTON.pkg,
                arrow: STORE_BUTTON.arrow || ARROW, tags: [], desc: '', mode: 'proxy', hidden: true
            });
            CONFIG.design = 'store';
        } else if (STORE_BUTTON.design) {
            CONFIG.design = STORE_BUTTON.design;
        }
        if (STORE_BUTTON.label) CONFIG.label = STORE_BUTTON.label;
        CONFIG.picker.enabled = false;
        CONFIG.picker.urlParam = false;
        CONFIG.picker.remember = false;
    }

    function groupById(id) {
        for (var i = 0; i < GROUPS.length; i++) if (GROUPS[i].id === id) return GROUPS[i];
        return null;
    }

    function designByKey(key) {
        for (var i = 0; i < DESIGNS.length; i++) if (DESIGNS[i].key === key) return DESIGNS[i];
        return null;
    }

    function designNumber(design) {
        return ('0' + design.n).slice(-2);
    }

    function scoped(key, lines) {
        var wrap = '.ta-pb-wrap.ta-pb-wrap[data-ta-design="' + key + '"]';
        var button = wrap + ' > .ta-pb.ta-pb';
        return lines.join('').split('%B').join(button).split('%W').join(wrap);
    }

    var W = '.ta-pb-wrap.ta-pb-wrap';
    var B = W + ' > .ta-pb.ta-pb';

    function proxyCss() {
        var base = [
            W + '{all:unset;box-sizing:border-box;position:relative;display:flex;align-items:stretch;justify-content:center;width:100%;max-width:100%;min-width:0;margin:0;padding:0;border:0;background:none;vertical-align:middle;color:#111;-webkit-font-smoothing:antialiased}',
            W + '.ta-pb-wrap--hidden{display:none}',
            B + '{all:unset;box-sizing:border-box;position:relative;isolation:isolate;display:inline-flex;align-items:center;justify-content:center;gap:.6em;flex:1 1 auto;width:100%;min-width:0;min-height:var(--ta-pb-h,52px);margin:0;padding:0 24px;border:0 solid transparent;border-radius:0;background:none;color:inherit;',
            'font:750 var(--ta-pb-fs,15px)/1.1 system-ui,-apple-system,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;letter-spacing:-.01em;text-transform:none;text-decoration:none;text-align:center;white-space:nowrap;',
            'box-shadow:none;transform:none;filter:none;opacity:1;cursor:pointer;user-select:none;-webkit-user-select:none;-webkit-tap-highlight-color:transparent;-webkit-appearance:none;appearance:none}',
            B + ':focus-visible{outline:2px solid #2563eb;outline-offset:3px}',
            W + ' .ta-pb__txt{all:unset;position:relative;z-index:3;display:inline-block;min-width:0;white-space:nowrap;pointer-events:none}',
            W + ' .ta-pb__roll{all:unset;display:inline}',
            W + ' .ta-pb__arrow{all:unset;position:relative;z-index:3;display:inline-block;line-height:1;pointer-events:none}',
            W + ' .ta-pb__icon{all:unset;position:relative;z-index:3;display:inline-flex;align-items:center;justify-content:center;pointer-events:none}',
            W + ' .ta-pb__layer{all:unset;position:absolute;inset:0;border-radius:inherit;pointer-events:none;z-index:0}',
            W + ' .ta-pb__cube,' + W + ' .ta-pb__face{all:unset;box-sizing:border-box;pointer-events:none}',
            '.' + SOURCE_CLASS + '.' + SOURCE_CLASS + '.' + SOURCE_CLASS + '{position:absolute!important;width:1px!important;height:1px!important;min-width:0!important;min-height:0!important;padding:0!important;margin:-1px!important;border:0!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;clip-path:inset(50%)!important;opacity:0!important;pointer-events:none!important;white-space:nowrap!important}'
        ];

        var designs = DESIGNS.filter(function (design) { return design.mode === 'proxy'; }).map(function (design) {
            var group = groupById(design.group);
            return scoped(design.key, (group ? group.css : []).concat(design.css || []));
        });

        var tail = [
            W + '[data-ta-design][data-ta-disabled] > .ta-pb.ta-pb:disabled{cursor:not-allowed;pointer-events:none;opacity:.5;transform:none;filter:grayscale(.35)}',
            W + '[data-ta-design][data-ta-disabled],' + W + '[data-ta-design][data-ta-disabled] *,' + W + '[data-ta-design][data-ta-disabled] *::before,' + W + '[data-ta-design][data-ta-disabled] *::after{animation-play-state:paused}',
            '@media (prefers-reduced-motion:reduce){' + W + ',' + W + ' *,' + W + ' *::before,' + W + ' *::after{animation-duration:.001ms!important;animation-iteration-count:1!important;transition-duration:.001ms!important}}'
        ];

        return base.join('') + designs.join('') + tail.join('');
    }

    function injectProxyStyle() {
        if (document.getElementById(PROXY_STYLE_ID)) return;
        var style = document.createElement('style');
        style.id = PROXY_STYLE_ID;
        style.textContent = proxyCss() + PACKAGE_CSS + PACKAGE_CSS_KONSTNARSFABRIKEN + PACKAGE_CSS_KIDNOVA;
        (document.head || document.documentElement).appendChild(style);
        injectStoreCss(style);
    }

    function injectStoreCss(style) {
        if (!STORE_BUTTON || !STORE_BUTTON.css) return;
        var link = document.getElementById(PROXY_STYLE_ID + '-store');
        if (!link) {
            link = document.createElement('link');
            link.id = PROXY_STYLE_ID + '-store';
            link.rel = 'stylesheet';
            link.href = STORE_BUTTON.css;
        }
        style.parentNode.insertBefore(link, style.nextSibling);
    }

    function injectWarpFilter() {
        if (document.getElementById(WARP_ID + '-svg') || !document.body) return;
        var holder = document.createElement('div');
        holder.innerHTML = '<svg id="' + WARP_ID + '-svg" width="0" height="0" aria-hidden="true" focusable="false" style="position:absolute;width:0;height:0;overflow:hidden;pointer-events:none">' +
            '<defs><filter id="' + WARP_ID + '" x="-20%" y="-20%" width="140%" height="140%">' +
            '<feTurbulence type="fractalNoise" baseFrequency=".012 .018" numOctaves="2" seed="8" result="noise"/>' +
            '<feGaussianBlur in="noise" stdDeviation="1.4" result="softNoise"/>' +
            '<feDisplacementMap in="SourceGraphic" in2="softNoise" scale="24" xChannelSelector="R" yChannelSelector="G"/>' +
            '</filter></defs></svg>';
        document.body.appendChild(holder.firstChild);
    }

    function buildPackageMarkup(design, label) {
        var wrap = document.createElement('span');
        wrap.className = 'ta-pb-wrap';
        wrap.setAttribute('data-ta-design', design.key);

        var cta = document.createElement('div');
        cta.className = 'ta-preorder-cta';

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'ta-preorder-btn ta-preorder-btn--' + design.pkg;

        var text = document.createElement('span');
        text.className = 'ta-btn__label';
        text.setAttribute('data-ta-label', '');
        button.appendChild(text);

        var arrow = document.createElement('span');
        arrow.className = 'ta-btn__arrow';
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = design.arrow || ARROW;
        button.appendChild(arrow);

        cta.appendChild(button);
        wrap.appendChild(cta);
        setLabel(wrap, label);
        return wrap;
    }

    function buildDesignMarkup(design, label) {
        if (design.pkg) return buildPackageMarkup(design, label);

        var wrap = document.createElement('span');
        wrap.className = 'ta-pb-wrap';
        wrap.setAttribute('data-ta-design', design.key);

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'ta-pb';

        (design.layers || []).forEach(function (name) {
            var layer = document.createElement('span');
            layer.className = 'ta-pb__layer ta-pb__layer--' + name;
            layer.setAttribute('aria-hidden', 'true');
            button.appendChild(layer);
        });

        if (design.icon && ICONS[design.icon]) {
            var icon = document.createElement('span');
            icon.className = 'ta-pb__icon';
            icon.setAttribute('aria-hidden', 'true');
            icon.innerHTML = ICONS[design.icon];
            button.appendChild(icon);
        }

        if (design.cube) {
            var cube = document.createElement('span');
            cube.className = 'ta-pb__cube';
            cube.setAttribute('aria-hidden', 'true');
            ['front', 'back'].forEach(function (side) {
                var face = document.createElement('span');
                face.className = 'ta-pb__face ta-pb__face--' + side;
                face.setAttribute('data-ta-label', '');
                cube.appendChild(face);
            });
            button.appendChild(cube);
        } else {
            var text = document.createElement('span');
            text.className = 'ta-pb__txt';
            var roll = document.createElement('span');
            roll.className = 'ta-pb__roll';
            roll.setAttribute('data-ta-label', '');
            text.appendChild(roll);
            button.appendChild(text);
        }

        if (design.arrow) {
            var arrow = document.createElement('span');
            arrow.className = 'ta-pb__arrow';
            arrow.setAttribute('aria-hidden', 'true');
            arrow.textContent = design.arrow;
            button.appendChild(arrow);
        }

        wrap.appendChild(button);
        setLabel(wrap, label);
        return wrap;
    }

    function setLabel(wrap, label) {
        wrap.querySelectorAll('[data-ta-label]').forEach(function (node) {
            if (node.textContent !== label) node.textContent = label;
            if (node.getAttribute('data-label') !== label) node.setAttribute('data-label', label);
        });
        var button = wrap.querySelector(BUTTON_SELECTOR);
        if (button && button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
    }

    function textOf(node) {
        var out = '';
        node.childNodes.forEach(function (child) {
            if (child.nodeType === 3) out += ' ' + child.nodeValue;
            else if (child.nodeType === 1 && !child.matches(LABEL_SKIP)) out += ' ' + textOf(child);
        });
        return out.replace(/\s+/g, ' ').trim();
    }

    function readLabel(source) {
        if (CONFIG.label) return CONFIG.label;
        if (!source) return CONFIG.fallbackLabel;
        if (source.tagName === 'INPUT') return (source.value || '').trim() || CONFIG.fallbackLabel;

        var data = window.TimesactData;
        var selectors = ['.timesact-button-text'];
        var custom = data && data.selectors && data.selectors.addToCartButtonText;
        if (custom) selectors.push(custom);
        selectors.push('span.btn-text');

        for (var i = 0; i < selectors.length; i++) {
            var element = null;
            try { element = source.querySelector(selectors[i]); } catch (error) { element = null; }
            if (!element) continue;
            var value = textOf(element) || (element.textContent || '').replace(/\s+/g, ' ').trim();
            if (value) return value;
        }

        return textOf(source) || CONFIG.fallbackLabel;
    }

    function surfaceOf(element) {
        return luminance(pickSurface(element)) > 0.6 ? 'light' : 'dark';
    }

    function toggleAttribute(element, name, on) {
        if (on && !element.hasAttribute(name)) element.setAttribute(name, '');
        if (!on && element.hasAttribute(name)) element.removeAttribute(name);
    }

    var records = [];
    var currentKey = null;
    var remeasure = false;

    function currentDesign() {
        return designByKey(currentKey) || designByKey('original');
    }

    function isOwn(node) {
        return !!(node && node.nodeType === 1 && node.closest && node.closest(OWN_SELECTOR));
    }

    function onProductScope(element) {
        if (!CONFIG.productPageOnly) return true;
        var data = window.TimesactData;
        var cardSelector = data && data.selectors && data.selectors.collection && data.selectors.collection.productCard;
        if (cardSelector) {
            try { if (element.closest(cardSelector)) return false; } catch (error) { }
        }
        if (data && data.page && typeof data.page.isProductPage === 'boolean') return data.page.isProductPage;
        return /\/products\//.test(location.pathname);
    }

    function isShown(element) {
        if (element.classList.contains(SOURCE_CLASS)) return true;
        return element.offsetParent !== null || getComputedStyle(element).position === 'fixed';
    }

    function collect() {
        var found = new Map();

        activeFeatures().forEach(function (feature) {
            document.querySelectorAll('.timesact-' + feature + '-button').forEach(function (button) {
                if (isOwn(button) || button.matches(CONFIG.skipSelector) || !onProductScope(button)) return;
                if (isShown(button)) found.set(button, feature);
            });
        });

        if (CONFIG.enhanceThemeButton && CONFIG.features.preOrder) {
            document.querySelectorAll(CONFIG.formSelector).forEach(function (form) {
                if (isOwn(form) || !form.querySelector(MARKERS) || !onProductScope(form)) return;
                var candidates = form.querySelectorAll(CONFIG.themeButtonSelector);
                for (var i = 0; i < candidates.length; i++) {
                    var button = candidates[i];
                    if (isOwn(button) || button.matches(CONFIG.skipSelector)) continue;
                    if (found.has(button)) break;
                    if (isShown(button)) {
                        found.set(button, 'preOrder');
                        break;
                    }
                }
            });
        }

        return found;
    }

    function recordFor(source) {
        for (var i = 0; i < records.length; i++) if (records[i].source === source) return records[i];
        return null;
    }

    function bindMagnetic(record) {
        var button = record.button;
        var move = function (event) {
            if (event.pointerType !== 'mouse' || button.disabled) return;
            var box = button.getBoundingClientRect();
            if (!box.width || !box.height) return;
            var x = (event.clientX - box.left - box.width / 2) / box.width;
            var y = (event.clientY - box.top - box.height / 2) / box.height;
            button.style.transform = 'translate(' + (x * 8).toFixed(2) + 'px,' + (y * 6).toFixed(2) + 'px)';
        };
        var leave = function () { button.style.transform = ''; };
        button.addEventListener('pointermove', move);
        button.addEventListener('pointerleave', leave);
    }

    function createProxy(source, design, feature) {
        var box = source.getBoundingClientRect();
        if (!box.width || !box.height || !source.parentNode) return null;

        var styles = getComputedStyle(source);
        var parent = source.parentElement;
        var parentStyles = getComputedStyle(parent);
        var inner = parent.clientWidth - (parseFloat(parentStyles.paddingLeft) || 0) - (parseFloat(parentStyles.paddingRight) || 0);
        var full = inner > 0 && box.width >= inner * 0.9;
        var height = Math.round(Math.max(44, Math.min(64, box.height)));

        var wrap = buildDesignMarkup(design, readLabel(source));
        wrap.setAttribute('data-ta-feature', feature);
        wrap.setAttribute('data-ta-surface', surfaceOf(source));
        wrap.style.setProperty('--ta-pb-h', height + 'px');
        wrap.style.width = full ? '100%' : Math.round(Math.max(box.width, 160)) + 'px';

        if (/flex|grid/.test(parentStyles.display)) {
            if (parseFloat(styles.flexGrow) > 0) wrap.style.flex = styles.flex;
            wrap.style.alignSelf = styles.alignSelf;
            wrap.style.order = styles.order;
            wrap.style.gridColumn = styles.gridColumn;
            wrap.style.gridRow = styles.gridRow;
        }
        wrap.style.marginTop = styles.marginTop;
        wrap.style.marginRight = styles.marginRight;
        wrap.style.marginBottom = styles.marginBottom;
        wrap.style.marginLeft = styles.marginLeft;

        var button = wrap.querySelector(BUTTON_SELECTOR);
        var record = {
            source: source,
            wrap: wrap,
            button: button,
            key: design.key,
            ariaHidden: source.getAttribute('aria-hidden'),
            tabIndex: source.getAttribute('tabindex')
        };

        button.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            if (button.disabled) return;
            source.click();
        });

        if (design.magnetic) bindMagnetic(record);

        source.parentNode.insertBefore(wrap, source);
        source.classList.add(SOURCE_CLASS);
        source.setAttribute('aria-hidden', 'true');
        source.setAttribute('tabindex', '-1');

        records.push(record);
        return record;
    }

    function updateProxy(record) {
        var source = record.source;
        setLabel(record.wrap, readLabel(source));

        var disabled = !!source.disabled || source.getAttribute('aria-disabled') === 'true';
        if (record.button.disabled !== disabled) record.button.disabled = disabled;
        toggleAttribute(record.wrap, 'data-ta-disabled', disabled);

        var hidden = source.hidden || source.style.display === 'none' || getComputedStyle(source).display === 'none';
        if (record.wrap.classList.contains('ta-pb-wrap--hidden') !== hidden) record.wrap.classList.toggle('ta-pb-wrap--hidden', hidden);
    }

    function teardown(record) {
        if (record.wrap.parentNode) record.wrap.parentNode.removeChild(record.wrap);
        var source = record.source;
        source.classList.remove(SOURCE_CLASS);
        if (record.ariaHidden === null) source.removeAttribute('aria-hidden');
        else source.setAttribute('aria-hidden', record.ariaHidden);
        if (record.tabIndex === null) source.removeAttribute('tabindex');
        else source.setAttribute('tabindex', record.tabIndex);
    }

    function sync() {
        injectStyle();
        injectProxyStyle();
        injectWarpFilter();

        var design = currentDesign();
        var found = collect();

        records = records.filter(function (record) {
            var keep = !remeasure && found.has(record.source) && record.key === design.key &&
                document.contains(record.source) && document.contains(record.wrap);
            if (!keep) teardown(record);
            return keep;
        });

        if (remeasure) found = collect();
        remeasure = false;

        document.querySelectorAll('[data-ta-fx]').forEach(function (element) {
            if (isOwn(element)) return;
            if (design.mode !== 'enhance' || !found.has(element) || element.getAttribute('data-ta-engine') !== design.engine) reset(element);
        });

        found.forEach(function (feature, element) {
            if (design.mode === 'proxy') {
                var record = recordFor(element) || createProxy(element, design, feature);
                if (record) updateProxy(record);
            } else if (design.mode === 'enhance') {
                enhance(element, feature, design.engine);
            }
        });

        syncPicker(found);
    }

    var scheduled = null;
    function schedule() {
        if (scheduled) clearTimeout(scheduled);
        scheduled = setTimeout(function () {
            scheduled = null;
            sync();
        }, 180);
    }

    function readParam(name) {
        try { return new URLSearchParams(location.search).get(name); } catch (error) { return null; }
    }

    function readStored() {
        try { return window.localStorage.getItem(STORAGE_KEY); } catch (error) { return null; }
    }

    function writeStored(key) {
        try { window.localStorage.setItem(STORAGE_KEY, key); } catch (error) { }
    }

    function pickerAllowed() {
        var param = CONFIG.picker.urlParam ? readParam('ta_picker') : null;
        if (param === '0') return false;
        if (param === '1') return true;
        return !!CONFIG.picker.enabled;
    }

    function initialDesign() {
        var fromUrl = CONFIG.picker.urlParam ? readParam('ta_design') : null;
        if (fromUrl && designByKey(fromUrl)) return fromUrl;
        if (pickerAllowed() && CONFIG.picker.remember) {
            var stored = readStored();
            if (stored && designByKey(stored)) return stored;
        }
        return designByKey(CONFIG.design) ? CONFIG.design : 'original';
    }

    var pickerCss = [
        '.ta-pbp{all:initial;position:fixed;top:0;left:0;right:0;z-index:2147483600;box-sizing:border-box;display:block;',
        'font:500 12px/1.35 system-ui,-apple-system,"Segoe UI",Roboto,Helvetica,Arial,sans-serif;color:#111827;',
        'background:rgba(255,255,255,.97);border-bottom:1px solid #e5e7eb;box-shadow:0 10px 30px -12px rgba(17,24,39,.28);',
        '-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px)}',
        '.ta-pbp *,.ta-pbp *::before,.ta-pbp *::after{box-sizing:border-box}',
        '.ta-pbp-inner{display:block;max-width:1320px;margin:0 auto;padding:10px 16px 12px}',
        '.ta-pbp-top{display:flex;align-items:center;gap:10px;flex-wrap:wrap}',
        '.ta-pbp-title{font-weight:700;font-size:13px;letter-spacing:-.01em;color:#111827}',
        '.ta-pbp-current{color:#4b5563;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:40vw}',
        '.ta-pbp-current b{color:#111827;font-weight:700}',
        '.ta-pbp-actions{margin-left:auto;display:flex;gap:6px;flex-wrap:wrap}',
        '.ta-pbp-act{display:inline-flex;align-items:center;justify-content:center;min-width:30px;height:30px;padding:0 10px;border-radius:8px;border:1px solid #e5e7eb;background:#fff;color:#111827;font-weight:600;cursor:pointer;user-select:none;outline:none;white-space:nowrap}',
        '.ta-pbp-act:hover{border-color:#9ca3af}',
        '.ta-pbp-act:focus-visible{box-shadow:0 0 0 2px #2563eb}',
        '.ta-pbp-body{display:block}',
        '.ta-pbp-tabs{display:flex;gap:4px;flex-wrap:wrap;margin-top:10px}',
        '.ta-pbp-tab{display:inline-flex;align-items:center;height:28px;padding:0 12px;border-radius:999px;background:#f3f4f6;color:#374151;font-weight:600;cursor:pointer;user-select:none;outline:none}',
        '.ta-pbp-tab:focus-visible{box-shadow:0 0 0 2px #2563eb}',
        '.ta-pbp-tab[aria-selected="true"]{background:#111827;color:#fff}',
        '.ta-pbp-grid{display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:8px;margin-top:10px}',
        '.ta-pbp-grid[hidden]{display:none}',
        '.ta-pbp-card{position:relative;display:flex;flex-direction:column;gap:6px;min-width:0;padding:8px;border:1px solid #e5e7eb;border-radius:10px;background:#fff;cursor:pointer;outline:none;transition:border-color .15s ease,box-shadow .15s ease}',
        '.ta-pbp-card:hover{border-color:#9ca3af}',
        '.ta-pbp-card:focus-visible{box-shadow:0 0 0 2px #2563eb}',
        '.ta-pbp-card[aria-checked="true"]{border-color:#111827;box-shadow:0 0 0 2px #111827}',
        '.ta-pbp-name{display:flex;gap:6px;align-items:baseline;min-width:0;font-weight:600;color:#111827}',
        '.ta-pbp-name span:last-child{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
        '.ta-pbp-num{font-variant-numeric:tabular-nums;color:#9ca3af;font-weight:700}',
        '.ta-pbp-mini{display:flex;align-items:center;justify-content:center;height:62px;padding:0 10px;border-radius:7px;background:#f6f6f4;overflow:hidden;pointer-events:none}',
        '.ta-pbp-mini .ta-pb-wrap{--ta-pb-h:40px;--ta-pb-fs:13px;--ta-pb-fs-ed:10px}',
        ':where(.ta-pbp-sample){display:inline-flex;align-items:center;justify-content:center;width:100%;height:40px;border-radius:8px;background:#111827;color:#fff;font:700 13px/1 system-ui,-apple-system,"Segoe UI",Roboto,sans-serif;position:relative}',
        '.ta-pbp-info{display:flex;gap:8px;align-items:baseline;flex-wrap:wrap;margin-top:10px;color:#4b5563}',
        '.ta-pbp-info b{color:#111827;font-weight:700}',
        '.ta-pbp-chip{display:inline-block;padding:2px 6px;border-radius:4px;background:#f3f4f6;color:#6b7280;font-size:10px;font-weight:600;text-transform:uppercase;letter-spacing:.05em}',
        '.ta-pbp[data-collapsed]{left:50%;right:auto;top:8px;transform:translateX(-50%);max-width:calc(100vw - 16px);border:1px solid #e5e7eb;border-radius:999px}',
        '.ta-pbp[data-collapsed] .ta-pbp-inner{padding:6px 6px 6px 14px}',
        '.ta-pbp[data-collapsed] .ta-pbp-body,.ta-pbp[data-collapsed] .ta-pbp-copy{display:none}',
        '.ta-pbp-spacer{display:block;height:0;margin:0;padding:0}',
        '.ta-pbp-toast{color:#059669;font-weight:600}',
        '@media (max-width:749px){',
        '.ta-pbp-grid{grid-template-columns:repeat(2,minmax(0,1fr))}',
        '.ta-pbp-body{max-height:52vh;overflow:auto}',
        '.ta-pbp-current{max-width:100%}',
        '.ta-pbp-actions{margin-left:0}',
        '}'
    ].join('');

    var picker = null;

    function injectPickerStyle() {
        if (document.getElementById(PICKER_STYLE_ID)) return;
        var style = document.createElement('style');
        style.id = PICKER_STYLE_ID;
        style.textContent = pickerCss;
        (document.head || document.documentElement).appendChild(style);
    }

    function makeAction(label, title, handler, extraClass) {
        var action = document.createElement('div');
        action.className = 'ta-pbp-act' + (extraClass ? ' ' + extraClass : '');
        action.setAttribute('role', 'button');
        action.setAttribute('tabindex', '0');
        action.setAttribute('title', title);
        action.textContent = label;
        action.addEventListener('click', handler);
        action.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                handler(event);
            }
        });
        return action;
    }

    function buildMini(design, label) {
        var mini = document.createElement('div');
        mini.className = 'ta-pbp-mini';

        if (design.mode === 'proxy') {
            var wrap = buildDesignMarkup(design, label);
            wrap.setAttribute('data-ta-surface', 'light');
            var button = wrap.querySelector(BUTTON_SELECTOR);
            button.setAttribute('tabindex', '-1');
            button.setAttribute('aria-hidden', 'true');
            mini.appendChild(wrap);
        } else {
            var sample = document.createElement('span');
            sample.className = 'ta-pbp-sample';
            var sampleText = document.createElement('span');
            sampleText.className = 'ta-pbp-sample-text';
            sampleText.textContent = label;
            sample.appendChild(sampleText);
            mini.appendChild(sample);
            mini._taSample = sample;
            mini._taSampleText = sampleText;
        }

        return mini;
    }

    function cycle(step) {
        var listed = DESIGNS.filter(function (design) { return !design.hidden; });
        var index = step > 0 ? -1 : 0;
        for (var i = 0; i < listed.length; i++) if (listed[i].key === currentKey) index = i;
        var next = listed[(index + step + listed.length) % listed.length];
        selectDesign(next.key, true);
    }

    function copyText(text, action, done) {
        var finish = function () {
            var previous = action.textContent;
            action.textContent = done;
            action.classList.add('ta-pbp-toast');
            setTimeout(function () {
                action.textContent = previous;
                action.classList.remove('ta-pbp-toast');
            }, 1400);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(finish, function () { legacyCopy(text); finish(); });
        } else {
            legacyCopy(text);
            finish();
        }
    }

    function legacyCopy(text) {
        var area = document.createElement('textarea');
        area.value = text;
        area.setAttribute('readonly', '');
        area.style.cssText = 'position:fixed;top:-1000px;opacity:0';
        document.body.appendChild(area);
        area.select();
        try { document.execCommand('copy'); } catch (error) { }
        document.body.removeChild(area);
    }

    function shareUrl() {
        var url = new URL(location.href);
        url.searchParams.set('ta_picker', '1');
        url.searchParams.set('ta_design', currentKey);
        return url.toString();
    }

    function buildPicker(label) {
        injectPickerStyle();

        var root = document.createElement('div');
        root.className = 'ta-pbp';
        root.id = PICKER_ID;
        root.setAttribute('role', 'region');
        root.setAttribute('aria-label', 'Timesact button styles');
        if (CONFIG.picker.startCollapsed) root.setAttribute('data-collapsed', '');

        var inner = document.createElement('div');
        inner.className = 'ta-pbp-inner';

        var top = document.createElement('div');
        top.className = 'ta-pbp-top';

        var title = document.createElement('span');
        title.className = 'ta-pbp-title';
        title.textContent = CONFIG.picker.heading;

        var current = document.createElement('span');
        current.className = 'ta-pbp-current';

        var actions = document.createElement('div');
        actions.className = 'ta-pbp-actions';
        actions.appendChild(makeAction('‹', 'Previous concept', function () { cycle(-1); }));
        actions.appendChild(makeAction('›', 'Next concept', function () { cycle(1); }));
        var copyConfig = makeAction('Copy config', 'Copy the setting for this concept', function () {
            copyText("design: '" + currentKey + "',", copyConfig, 'Copied');
        }, 'ta-pbp-copy');
        var copyLink = makeAction('Copy link', 'Copy a link that opens this page on this concept', function () {
            copyText(shareUrl(), copyLink, 'Copied');
        }, 'ta-pbp-copy');
        actions.appendChild(copyConfig);
        actions.appendChild(copyLink);
        var toggle = makeAction('Hide', 'Collapse or expand the panel', function () {
            if (root.hasAttribute('data-collapsed')) root.removeAttribute('data-collapsed');
            else root.setAttribute('data-collapsed', '');
            toggle.textContent = root.hasAttribute('data-collapsed') ? 'Show' : 'Hide';
            updateSpacer();
        });
        if (root.hasAttribute('data-collapsed')) toggle.textContent = 'Show';
        actions.appendChild(toggle);

        top.appendChild(title);
        top.appendChild(current);
        top.appendChild(actions);

        var body = document.createElement('div');
        body.className = 'ta-pbp-body';

        var tabs = document.createElement('div');
        tabs.className = 'ta-pbp-tabs';
        tabs.setAttribute('role', 'tablist');

        var grids = {};
        var tabNodes = {};
        var cards = {};

        GROUPS.forEach(function (group) {
            var tab = document.createElement('div');
            tab.className = 'ta-pbp-tab';
            tab.setAttribute('role', 'tab');
            tab.setAttribute('tabindex', '0');
            tab.textContent = group.label;
            var open = function () { showGroup(group.id); };
            tab.addEventListener('click', open);
            tab.addEventListener('keydown', function (event) {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    open();
                }
            });
            tabs.appendChild(tab);
            tabNodes[group.id] = tab;

            var grid = document.createElement('div');
            grid.className = 'ta-pbp-grid';
            grid.setAttribute('role', 'radiogroup');
            grid.setAttribute('aria-label', group.label);
            grid.hidden = true;
            grids[group.id] = grid;
        });

        DESIGNS.forEach(function (design) {
            if (design.hidden) return;
            var card = document.createElement('div');
            card.className = 'ta-pbp-card';
            card.setAttribute('role', 'radio');
            card.setAttribute('tabindex', '0');
            card.setAttribute('aria-checked', 'false');
            card.setAttribute('data-key', design.key);
            card.setAttribute('title', design.desc || design.name);

            var name = document.createElement('div');
            name.className = 'ta-pbp-name';
            var number = document.createElement('span');
            number.className = 'ta-pbp-num';
            number.textContent = designNumber(design);
            var text = document.createElement('span');
            text.textContent = design.name;
            name.appendChild(number);
            name.appendChild(text);

            var mini = buildMini(design, label);
            card.appendChild(name);
            card.appendChild(mini);

            var choose = function () { selectDesign(design.key, true); };
            card.addEventListener('click', choose);
            card.addEventListener('keydown', function (event) {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    choose();
                } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
                    event.preventDefault();
                    cycle(1);
                    focusCurrentCard();
                } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
                    event.preventDefault();
                    cycle(-1);
                    focusCurrentCard();
                }
            });

            grids[design.group].appendChild(card);
            cards[design.key] = { card: card, mini: mini };
        });

        if (GROUPS.length > 1) body.appendChild(tabs);
        GROUPS.forEach(function (group) { body.appendChild(grids[group.id]); });

        var info = document.createElement('div');
        info.className = 'ta-pbp-info';
        body.appendChild(info);

        inner.appendChild(top);
        inner.appendChild(body);
        root.appendChild(inner);

        var spacer = document.createElement('div');
        spacer.className = 'ta-pbp-spacer';
        spacer.setAttribute('aria-hidden', 'true');
        document.body.insertBefore(spacer, document.body.firstChild);
        document.body.appendChild(root);

        picker = {
            root: root,
            spacer: spacer,
            current: current,
            info: info,
            grids: grids,
            tabs: tabNodes,
            cards: cards,
            label: label,
            group: null
        };

        DESIGNS.forEach(function (design) {
            if (design.mode !== 'enhance') return;
            var sample = cards[design.key].mini._taSample;
            if (activeStyle(design.engine) === 'glass') enhanceGlass(sample, 'preOrder');
            else enhanceGlow(sample, 'preOrder');
        });

        renderPicker();
        if (typeof ResizeObserver !== 'undefined') {
            new ResizeObserver(updateSpacer).observe(root);
        }
    }

    function focusCurrentCard() {
        if (!picker || !picker.cards[currentKey]) return;
        picker.cards[currentKey].card.focus();
    }

    function showGroup(id) {
        if (!picker) return;
        picker.group = id;
        GROUPS.forEach(function (group) {
            picker.grids[group.id].hidden = group.id !== id;
            picker.tabs[group.id].setAttribute('aria-selected', group.id === id ? 'true' : 'false');
        });
        updateSpacer();
    }

    function renderPicker() {
        if (!picker) return;
        var design = currentDesign();
        var group = groupById(design.group);

        Object.keys(picker.cards).forEach(function (key) {
            picker.cards[key].card.setAttribute('aria-checked', key === design.key ? 'true' : 'false');
        });

        picker.current.innerHTML = '';
        picker.current.appendChild(document.createTextNode((group ? group.label : '') + ' · '));
        var strong = document.createElement('b');
        strong.textContent = designNumber(design) + ' ' + design.name;
        picker.current.appendChild(strong);

        picker.info.innerHTML = '';
        var heading = document.createElement('b');
        heading.textContent = designNumber(design) + ' — ' + design.name;
        picker.info.appendChild(heading);
        picker.info.appendChild(document.createTextNode(design.desc || ''));
        (design.tags || []).forEach(function (tag) {
            var chip = document.createElement('span');
            chip.className = 'ta-pbp-chip';
            chip.textContent = tag;
            picker.info.appendChild(chip);
        });

        showGroup(design.group);
    }

    function updateSpacer() {
        if (!picker) return;
        var height = picker.root.hasAttribute('data-collapsed') ? 0 : picker.root.offsetHeight;
        var value = height + 'px';
        if (picker.spacer.style.height !== value) picker.spacer.style.height = value;
    }

    function syncPicker(found) {
        if (!pickerAllowed() || !document.body) return;
        if (!picker && !found.size) return;

        var first = null;
        found.forEach(function (feature, element) { if (!first) first = element; });
        var label = first ? readLabel(first) : (picker ? picker.label : CONFIG.fallbackLabel);

        if (!picker) {
            buildPicker(label);
            return;
        }

        if (!document.body.contains(picker.root)) document.body.appendChild(picker.root);
        if (!document.body.contains(picker.spacer)) document.body.insertBefore(picker.spacer, document.body.firstChild);

        if (label !== picker.label) {
            picker.label = label;
            Object.keys(picker.cards).forEach(function (key) {
                var mini = picker.cards[key].mini;
                var wrap = mini.querySelector('.ta-pb-wrap');
                if (wrap) setLabel(wrap, label);
                if (mini._taSampleText && mini._taSampleText.textContent !== label) mini._taSampleText.textContent = label;
            });
        }
    }

    function revealButton() {
        var target = null;
        if (records.length) target = records[0].wrap;
        if (!target) {
            var enhanced = document.querySelector('[data-ta-fx]:not(.ta-pbp-sample)');
            if (enhanced && !isOwn(enhanced)) target = enhanced;
        }
        if (!target) {
            var found = collect();
            found.forEach(function (feature, element) { if (!target) target = element; });
        }
        if (!target) return;

        var box = target.getBoundingClientRect();
        var offset = picker && !picker.root.hasAttribute('data-collapsed') ? picker.root.offsetHeight : 0;
        if (box.top < offset + 8 || box.bottom > window.innerHeight - 8) {
            window.scrollBy({ top: box.top - offset - (window.innerHeight - offset) / 2 + box.height / 2, behavior: 'smooth' });
        }
    }

    function selectDesign(key, fromUser) {
        if (!designByKey(key)) return;
        currentKey = key;
        if (pickerAllowed() && CONFIG.picker.remember) writeStored(key);
        renderPicker();
        sync();
        if (fromUser) revealButton();
    }

    function start() {
        currentKey = initialDesign();
        sync();

        new MutationObserver(function (mutations) {
            for (var i = 0; i < mutations.length; i++) {
                var mutation = mutations[i];
                var target = mutation.target;
                if (!target || target.nodeType !== 1) continue;
                if (isOwn(target)) continue;
                if (target.classList &&
                    (target.classList.contains(LAYER_CLASS) || target.classList.contains(SHEEN_CLASS))) continue;
                if (mutation.type === 'attributes' && mutation.attributeName === 'style' && target.hasAttribute('data-ta-fx')) continue;
                if (mutation.type === 'childList') {
                    var nodes = Array.prototype.slice.call(mutation.addedNodes).concat(Array.prototype.slice.call(mutation.removedNodes));
                    if (!nodes.length) continue;
                    var foreign = nodes.some(function (node) {
                        if (node.nodeType !== 1) return true;
                        if (node.classList && (node.classList.contains(LAYER_CLASS) || node.classList.contains(SHEEN_CLASS))) return false;
                        return !node.matches(OWN_SELECTOR);
                    });
                    if (foreign) return schedule();
                    continue;
                }
                if (mutation.type === 'attributes') return schedule();
            }
        }).observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'value', 'style', 'disabled', 'aria-disabled', 'hidden']
        });

        ['shopify:section:load', 'variant:change', 'change'].forEach(function (name) {
            document.addEventListener(name, schedule, true);
        });

        var width = window.innerWidth;
        window.addEventListener('resize', function () {
            if (Math.abs(window.innerWidth - width) > 40) {
                width = window.innerWidth;
                remeasure = true;
            }
            updateSpacer();
            schedule();
        });
    }

    window.TimesactEnhance = {
        config: CONFIG,
        designs: DESIGNS.map(function (design) {
            return { key: design.key, group: design.group, number: design.n, name: design.name, description: design.desc, tags: design.tags };
        }),
        select: function (key) { selectDesign(key, false); },
        current: function () { return currentKey; },
        refresh: function () {
            records.slice().forEach(teardown);
            records = [];
            document.querySelectorAll('[data-ta-fx]').forEach(function (element) {
                if (!isOwn(element)) reset(element);
            });
            filters.cache = {};
            if (filters.node) {
                filters.node.remove();
                filters.node = null;
            }
            [STYLE_ID, PROXY_STYLE_ID].forEach(function (id) {
                var style = document.getElementById(id);
                if (style) style.remove();
            });
            sync();
        }
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }
})();

